/**
 * @license
 * @qwik.dev/core 2.0.0-beta.43-dev+0d0e43e
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as Ve, isBrowser as ze } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { getAsyncLocalStorage as Be } from "@qwik.dev/core/async-local-storage";

export { getAsyncLocalStorage as _getAsyncLocalStorage } from "@qwik.dev/core/async-local-storage";

import { p as We } from "@qwik.dev/core/preloader";

const Ue = !1;

const He = (t, ...n) => Ye(!1, t, ...n);

const Je = (t, ...n) => Ye(!0, t, ...n);

const Ye = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

const Ge = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Ze = t => typeof t === "object" && t !== null;

const Ke = t => Array.isArray(t);

const tr = t => typeof t === "string";

const nr = t => typeof t === "function";

const er = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = Ye(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const rr = "2.0.0-beta.43-dev+0d0e43e";

const ir = "<sync>";

const sr = t => typeof t === "function" && typeof t.getSymbol === "function";

const bd = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const or = "q:renderFn";

const lr = "q:componentHash";

const ur = "q:targetEl";

const cr = "⚡️";

const fr = "q:slot";

const ar = "q:sparent";

const hr = "q:s";

const dr = "[q\\:patch]";

const pr = "q:r";

const _d = "q:rp";

const $r = "q:ebc";

const yr = "q:style";

const wr = "style[q\\:style]";

const mr = wr + ",style[q\\:sstyle]";

const vr = "q:sstyle";

const br = "q:ctx";

const _r = "q:brefs";

const gr = (t, n) => t["qFuncs_" + n] || [];

const Er = "q:base";

const Sr = "q:container-island";

const kr = "/" + Sr;

const Rr = "q:ignore";

const Pr = "/" + Rr;

const Tr = "q:container";

const Ar = "/" + Tr;

const qr = "q:template";

const Ir = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const Mr = "http://www.w3.org/1999/xhtml";

const Nr = "http://www.w3.org/2000/svg";

const xr = "http://www.w3.org/1998/Math/MathML";

const Cr = "qRender";

const Or = "q-e:qvisible";

const jr = "q:id";

const Lr = "q:key";

const Fr = "q:props";

const Xr = "q:seq";

const Dr = "q:seqIdx";

const Wr = "q:p";

const Vr = "q:ps";

const Ur = ":on";

const Br = ":onIdx";

const Qr = ":onFlags";

const Hr = ":cursorBoundary";

const Jr = ":nearestCursorBoundary";

const Yr = ":";

const Gr = "dangerouslySetInnerHTML";

const Kr = () => ({
    isServer: Ve,
    importSymbol(t, n, e) {
        if (Ve) {
            const t = bd(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw er(6, [ e ]);
        }
        if (!n) {
            throw er(14, [ e ]);
        }
        if (!t) {
            throw er(13, [ n, e ]);
        }
        const s = ti(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const ti = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Er) ?? s, s);
    return new URL(e, o);
};

let ni = /*#__PURE__ */ Kr();

const ei = t => ni = t;

const ri = () => ni;

const gd = () => ni.isServer;

/*@__INLINE__*/ const ii = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const si = (t, n, e, s, o = !1) => {
    const r = ii(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const oi = (t, n, e) => {
    const s = ii(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const li = (t, n, e) => ii(t, n, e) >= 0;

const ui = t => t.nodeType === 1;

const ci = 100;

const fi = t => {
    try {
        return !!t && typeof t == "object" && typeof t.then === "function";
    } catch {
        return !1;
    }
};

const ai = (t, n, e) => {
    try {
        const s = t();
        return fi(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const hi = (t, n) => fi(t) ? t.then(n) : n(t);

const di = t => new Promise(n => {
    setTimeout(n, t);
});

const pi = t => {
    throw t;
};

function t(t, n = pi) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!fi(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = ci;
    const r = async e => {
        for (;fi(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!fi(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const $i = t => {
    const n = t.$n;
    return n || t;
};

const Ed = t => t.Mt;

const yi = Symbol();

class wi {
    [yi]=void 0;
}

const mi = "q:type";

const vi = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const gi = 124;

const Ei = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

const Si = t => t === "foreignObject";

const ki = t => t === "svg" || Si(t);

const Ri = t => t === "math";

function n(t, e, s, o = !1) {
    const r = t.ownerDocument.createElementNS(s, e);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== Yr && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let e = 0; e < t.childNodes.length; e++) {
            const i = t.childNodes[e];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(n(i, i.localName, s, o));
        }
    }
    return r;
}

const Pi = {
    elementNamespace: Mr,
    elementNamespaceFlag: 0
};

function e(t, n) {
    const e = !t || !!Wl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && Si(Wl(t));
    let o = Mr;
    let r = 0;
    const i = typeof n === "string" || cl(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return ki(t);
        }
        if (cl(t)) {
            return ki(Wl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = Nr;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Ri(t);
        }
        if (cl(t)) {
            return Ri(Wl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = xr;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? Nr : e ? xr : Mr;
        r = t.flags & 1536;
    }
    Pi.elementNamespace = o;
    Pi.elementNamespaceFlag = r;
    return Pi;
}

const Ti = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function r(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Ai(t.slice(s, -1));
        }
    }
    return null;
}

const Ai = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = qi(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const qi = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Ii = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

class Mi {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [yi]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Ni extends Mi {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class xi extends Ni {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class Ci extends Mi {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Oi = [];

const ji = [];

function i(t, n) {
    const e = $(n).priority;
    let s = Oi.length;
    for (let t = 0; t < Oi.length; t++) {
        const n = $(Oi[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Oi.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function s() {
    for (let t = 0; t < Oi.length; t++) {
        const n = Oi[t];
        let e = !1;
        for (let t = 0; t < ji.length; t++) {
            const s = ji[t];
            if (fu(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function o(t, n) {
    ji.push(t);
    c(t, n, !0);
    n.o++;
}

function l(t, n) {
    f(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    i(n, t);
}

function u(t, n, e) {
    const s = $(e);
    if (!s || s === n) {
        return;
    }
    c(e, t, !1);
    f(e, t);
    p(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function c(t, n, e) {
    e || (t.flags &= -257);
    const s = Oi.indexOf(t);
    if (s !== -1) {
        Oi.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function f(t, n) {
    const e = ji.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = ji.length - 1;
    e !== s && (ji[e] = ji[s]);
    ji.pop();
    n.o--;
    return !0;
}

const Li = new WeakMap;

const Fi = ":nodeProps";

const Xi = ":nodeDiff";

const Di = ":errorData";

const Wi = ":signal";

const Vi = ":inlineComponentData";

const zi = new WeakMap;

function a(t, n) {
    let e = zi.get(t);
    e || zi.set(t, e = []);
    e.includes(n) || e.push(n);
}

function h(t) {
    const n = zi.get(t);
    n && zi.delete(t);
    return n;
}

function d(t, n, e) {
    n.position = e;
    e && $n(e) && function s(t, n, e) {
        const s = $(e);
        if (!s || s === n) {
            return;
        }
        c(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = h(n);
            if (s) {
                for (let n = 0; n < s.length; n++) {
                    a(t, s[n]);
                }
            }
            const o = n.extraPromises;
            if (o && o.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...o) : t.extraPromises = o;
            }
            p(t, n);
        })(n, s);
    }(t, n, e);
}

function p(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function $(t) {
    return Li.get(t) ?? null;
}

const Ui = Symbol();

const Bi = Symbol();

const Qi = Symbol();

const Hi = Symbol();

const Ji = Symbol();

const Yi = Symbol();

const Gi = [];

const Zi = {};

Object.freeze(Gi);

Object.freeze(Zi);

function y(t) {
    return new Proxy({}, new Ki(t));
}

class Ki {
    owner;
    ht=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Ui) {
            return this.owner.constProps;
        }
        if (n === Bi) {
            return this.owner.varProps;
        }
        if (n === Qi) {
            return this.owner;
        }
        if (n === Hi) {
            return this;
        }
        let e;
        if (n === "children") {
            e = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            e = es(this.owner, n);
            n in this.owner.varProps && ts(this, n);
        }
        return e instanceof Ms ? e.value : e;
    }
    set(t, n, e) {
        if (n === Qi) {
            this.owner = e;
        } else if (n === "children") {
            this.owner.children = e;
        } else if (n === Ui) {
            this.owner.constProps = e;
        } else if (n === Bi) {
            this.owner.varProps = e;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === Zi ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== e) {
                this.owner.varProps[n] = e;
                ns(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && ns(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Ui || n === Bi) {
            return !0;
        }
        const e = n in this.owner.varProps;
        if (typeof n === "string") {
            e && ts(this, n);
            if (typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
        }
        return e || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const ts = (t, n) => {
    const e = Qf();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.hn;
    s && Cn(t.owner._proxy, n, t, s);
};

const ns = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ht, n);
    e && Au(t.$, t, e);
    return !!e;
};

const es = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const rs = (t, n) => is(t)?.[n] || ss(t)?.[n] || null;

const is = t => {
    if (!t) {
        return null;
    }
    return Bi in t ? "children" in t ? {
        ...t[Bi],
        children: t.children
    } : t[Bi] : t;
};

const ss = t => {
    if (!t) {
        return null;
    }
    return Ui in t ? t[Ui] : null;
};

const os = t => t && Bi in t;

const ls = Symbol();

class us {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const cs = Symbol();

const fs = Symbol();

const as = Symbol();

function w(t, n, e) {
    t[yi] || (Ve && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(_r, new Map) : t[yi] = new Map);
    const o = t[yi];
    let r = o.get(n);
    if (!r) {
        r = new us(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const hs = (t, n) => (e, s) => {
    const o = Xe();
    o.hn = w(t, ":");
    o.$ = n || void 0;
    return je(o, () => {
        if (nr(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Su(e)) {
            return e.value;
        }
        if (Ze(e) && Xu(e)) {
            Cn(Ou(e), as, Cu(e), o.hn);
            return e;
        }
        throw er(2);
    });
};

class ds {
    Dt;
    ht=void 0;
    $=null;
    yn=null;
    constructor(t, n) {
        this.$ = t || Qf()?.$ || null;
        this.Dt = n;
    }
    trigger() {
        Au(this.$, this, this.ht);
    }
    force() {
        Au(this.$, this, this.ht);
    }
    get untrackedValue() {
        return this.Dt;
    }
    set untrackedValue(t) {
        this.Dt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = Qf();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.hn;
        if (e) {
            const t = Ve;
            const s = this.ht ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            ku(s, e);
            Ru(e, this);
            if (t) {
                const t = Tu(n.$, this.$);
                o && t?.wn?.(this, e, null);
                Pu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.Dt) {
            this.Dt = t;
            Au(this.$, this, this.ht);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Dt
        };
    }
}

class ps {
    mn;
    vn=null;
    bn=!1;
    _n=!0;
    constructor(t, n, e) {
        this.mn = t;
        if (n !== void 0) {
            this.info = n;
            this.gn = e;
        }
    }
    get track() {
        return this.En ||= hs(this.mn, this.mn.$);
    }
    get abortSignal() {
        return (this.Sn ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.mn.Dt;
        if (t !== ls) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.kn ||= []).push(t);
    }
}

class $s extends ds {
    Wt;
    h;
    [yi]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || Qf()?.$, ls);
        this.Wt = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.Dt = typeof o === "function" ? o() : o);
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.Ut = r;
            this.Bt = [];
        }
        s.timeout && (this.Qt = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
    }
    clear() {
        this.Dt = ls;
        this.invalidate();
    }
    invalidate(n) {
        if (arguments.length > 0) {
            this.Rn = n;
            this.gn = this.gn === void 0 ? 1 : this.gn + 1;
        }
        if (this.h & 512) {
            this.Pn(!0);
            return;
        }
        this.h |= 1;
        const e = Xe();
        e.$ = this.$ || void 0;
        const s = t(Le.bind(this, e, this.p));
        fi(s) && s.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.Rn = void 0;
            if (this.Bt) {
                for (let t = 0; t < this.Bt.length; t++) {
                    this.Bt[t]._n = !1;
                }
            } else {
                this.lt && (this.lt._n = !1);
            }
            super.value = t;
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.p();
        if (this.lt?.vn) {
            if (this.Dt === ls || Ve) {
                throw this.lt?.vn;
            }
            return this.Dt;
        }
        if (this.Vt) {
            throw this.Vt;
        }
        if (Ve && this.h & 64 && this.Dt === ls) {
            throw er(35);
        }
        return this.Dt;
    }
    set untrackedValue(t) {
        this.Dt = t;
    }
    get pending() {
        const t = this.untrackedPending;
        const n = Qf();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.hn;
            if (t) {
                ku(this.wt ||= new Set, t);
                Ru(t, this);
                Pu(t, this.$);
            }
        }
        return t;
    }
    set untrackedPending(t) {
        if (t !== !!this.zt) {
            this.zt = t;
            Au(this.$, this, this.wt);
        }
    }
    get untrackedPending() {
        this.p();
        if (Ve && this.lt?.vn) {
            throw this.lt?.vn;
        }
        return !!this.zt;
    }
    get loading() {
        return this.pending;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        const n = Qf();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.hn;
            if (t) {
                ku(this.vt ||= new Set, t);
                Ru(t, this);
                Pu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.Vt) {
            this.Vt = t;
            Au(this.$, this, this.vt);
        }
    }
    get untrackedError() {
        this.p();
        if (Ve && this.lt?.vn) {
            throw this.lt?.vn;
        }
        return this.Vt;
    }
    Pn(t) {
        this.h |= 1;
        t && (this.ht?.size || this.wt?.size || this.vt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.lt && this.Tn(this.lt, t);
    }
    bt() {
        if (!(this.h & 32) || this.An()) {
            return;
        }
        if (!ze) {
            return;
        }
        setTimeout(() => {
            this.An() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.lt?.vn; ) {
            await (this.lt?.vn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.qn();
        }
        const n = this.Wt;
        Eu(n);
        const e = this.lt;
        if (e && !e.bn) {
            e.bn = !0;
            e.Sn?.abort();
            this.In(e);
        }
        const s = new ps(this, this.Rn, this.gn);
        this.lt = s;
        let o;
        try {
            o = this.Mn(n.resolved, s);
        } catch (t) {
            if (fi(t)) {
                throw t;
            }
            s.gn === this.gn && (this.Rn = void 0);
            this.h &= -2;
            this.Nn(s, t);
            return;
        }
        if (fi(o)) {
            this.h |= 512;
            this.h &= -2;
            let n = o;
            const e = () => {
                const t = n ?? this.Mn(this.Wt.resolved, s);
                n = void 0;
                return t;
            };
            s.vn = this.xn(s, () => t(e));
            return;
        }
        s.gn === this.gn && (this.Rn = void 0);
        this.h &= -2;
        this.untrackedError = void 0;
        super.value = o;
    }
    Mn(t, n) {
        const e = t;
        if (this.h & 1024) {
            let t = Qf();
            t?.hn && (t = {
                ...t,
                hn: void 0
            });
            return Le(t, e, [ n ]);
        }
        const s = this.$ ||= Qf()?.$ || null;
        const o = w(this, ".");
        s && Tn(s, o);
        const r = Xe();
        r.$ = s || void 0;
        r.hn = o;
        return Le(r, e, [ n ]);
    }
    qn() {
        if (Ve && this.h & 64) {
            this.zt = !0;
            this.$?.serializationCtx.ke.add(this);
            return;
        }
        this.h &= -2;
        const t = this.lt;
        t && this.Tn(t);
        const n = this.Ut === 0 ? Infinity : this.Ut ?? 1;
        if (this.Bt ? this.Bt.length >= n : t?.vn) {
            this.h |= 1;
            return;
        }
        const e = this.gn;
        const s = new ps(this, this.Rn, e);
        this.lt = s;
        this.Bt && this.Bt.push(s);
        s.vn = this.Cn(s);
    }
    async Cn(n) {
        let e = this.Wt.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.Wt.resolve();
            if (n.Sn?.signal.aborted) {
                n.vn = null;
                return;
            }
        }
        this.Qt && (this.On = setTimeout(() => {
            const t = Error(`timeout ${this.Qt}ms`);
            this.Nn(n, t);
            n.Sn?.abort(t);
        }, this.Qt));
        return this.xn(n, () => t(() => this.Mn(e, n)));
    }
    async xn(t, n) {
        try {
            const e = n();
            let s;
            if (fi(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t.vn = null;
            if (t._n) {
                const n = this.Bt;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s]._n = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = s;
            }
        } catch (n) {
            t.vn = null;
            this.Nn(t, n);
        }
        if ((() => t === this.lt)()) {
            clearTimeout(this.On);
            t.gn === this.gn && (this.Rn = void 0);
            this.h & 1 ? this.p() : this.untrackedPending = !1;
        }
    }
    Nn(t, n) {
        if (t !== this.lt || !t._n) {
            return;
        }
        t._n = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = ls;
    }
    async jn() {
        clearTimeout(this.On);
        const t = this.lt;
        t && this.Tn(t);
        this.Bt ? await Promise.all(this.Bt.map(t => t.vn)) : await (t?.vn);
    }
    An() {
        return !!(this.ht?.size || this.wt?.size || this.vt?.size);
    }
    Tn(t, n) {
        if (t.bn) {
            return;
        }
        t.bn = !0;
        t.Sn?.abort(n);
        t.vn = hi(t.vn, () => this.Ln(t));
    }
    In(t) {
        const n = t.kn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    fi(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Ln(t) {
        const n = () => {
            t.vn = null;
            const n = this.Bt;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.p();
        };
        const e = this.In(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

const ys = t => (n, ...e) => t.call(null, Ta(n), ...e);

class ws extends $s {
    constructor(t, n) {
        super(t, n, 17);
    }
    Fn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Eu(this.Wt);
        const t = Gf(this.Wt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Dt === ls ? e : this.Dt;
        const r = Kf(() => this.Fn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Fn = !0;
        this.h &= -2;
        const i = this.Fn && r !== "undefined" || r !== this.Dt;
        if (i) {
            this.Dt = r;
            Au(this.$, this, this.ht);
        }
    }
}

class ms extends $s {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

const vs = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const bs = (t, n) => new $s(n?.container || null, t, Iu(n?.serializationStrategy || "always"), n);

const _s = (t, n) => new ms(n?.container || null, t, Iu(n?.serializationStrategy || "always"), n);

const gs = t => new ws(null, t);

const Es = t => new ds(null, t);

const Ss = /*#__PURE__*/ ys(bs);

const ks = ys(gs);

const Rs = t => t.value;

const Ps = (t, n) => t[n];

const Ts = t => {
    if (t.length === 1) {
        if (Su(t[0])) {
            return t[0].yn ||= new Ms(null, Rs, t, null);
        }
        if (Xu(t[0])) {
            return new Ms(null, Rs, t, null);
        }
        return t[0].value;
    }
    return new Ms(null, Ps, t, null);
};

const As = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Ze(n)) {
        return n[e];
    }
    if (Su(n)) {
        if (n instanceof Ms) {
            return n;
        }
        return Ts(t);
    }
    if (os(n)) {
        const s = n[Ui];
        const o = n[Bi];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return qs(n, t);
        }
    } else {
        const s = Ou(n);
        if (s) {
            const n = s[e];
            return qs(n, t);
        }
    }
    return n[e];
};

const qs = (t, n) => Su(t) ? t : Ts(n);

const Is = (t, n) => {
    const e = As(t, n);
    if (e === Ji) {
        return t[n];
    }
    return e;
};

class Ms extends ds {
    ct;
    ut;
    Pt;
    h;
    _=void 0;
    [yi]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, ls);
        this.ct = e;
        this.ut = n;
        this.Pt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this._) {
                this.$.setHostProp(this._, Wi, this);
                mn(this.$, this._, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Au(this.$, this, this.ht);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Dt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = Kf(() => this.ut(...this.ct), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Dt;
        if (n) {
            this.h |= 2;
            this.Dt = t;
        }
    }
    st() {
        return this.ut === Rs && Su(this.ct[0]) ? this.ct[0] : this;
    }
    set value(t) {
        throw er(31);
    }
    get value() {
        return super.value;
    }
}

class Ns {
    data;
    constructor(t) {
        this.data = t;
    }
}

const xs = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

Object.prototype.hasOwnProperty;

class Cs {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || xs(n) ? Zi : n;
        this.constProps = !e || xs(e) ? null : e;
    }
    get props() {
        return this._proxy ||= y(this);
    }
}

const Os = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const js = t => t instanceof Cs;

const Ls = (t, n, e) => {
    if (typeof t === "string") {
        const s = Ie(n);
        return Vf(s, () => {
            $a(ya(s, t));
            return e();
        });
    }
    return e();
};

function m(t, n) {
    return Ls(this, n, () => {
        const t = pa[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function v(t, n) {
    return Ls(this, n, () => {
        const t = pa[0];
        t.value = n.checked;
    });
}

function b(t, n) {
    return Ls(this, n, () => {
        if (pa) {
            for (let t = 0; t < pa.length; t++) {
                const n = pa[t];
                n instanceof ms && n.h & 64 && n.p();
            }
        }
    });
}

const Fs = "bind:value";

const Xs = "bind:checked";

const Ds = "passive:";

const Ws = "preventdefault:";

const Vs = Object.prototype.hasOwnProperty;

const zs = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Ai(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const Us = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Ai(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Ai(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Ai(t.slice(11, -1));
    }
    return null;
};

const Bs = (t, n, e, s, o = !1) => {
    let i = t;
    let c = o;
    for (let t = 0; t < n.length; t++) {
        const o = n[t];
        const l = Us(o);
        const u = r(o, s.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = e.get(u);
            (t === void 0 || t < e.get(o)) && (i[u] = i[o]);
            delete i[o];
        }
    }
    return i;
};

const Qs = (t, n, e, s, o, r, i) => new Cs(t, n, e, s, o, r, !1, i);

const Hs = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(Ds)) {
                    r.push(o);
                    t.add(Ai(o.slice(8)));
                } else {
                    o.startsWith(Ws) ? h.push(o) : Us(o) !== null ? s.push(o) : o === Xs ? a = e[o] : o === Fs && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(Ds)) {
                    i.push(s);
                    t.add(Ai(s.slice(8)));
                } else {
                    s.startsWith(Ws) ? d.push(s) : Us(s) !== null ? o.push(s) : s === Xs ? a = n[s] : s === Fs && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = zs(e, r, h, t, l);
            l = l || e !== n;
            e = Bs(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = zs(n, i, d, t, u);
            u = u || n !== e;
            n = Bs(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && Vs.call(n, Xs) && delete n[Xs];
                if (e && Vs.call(e, Xs)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Xs];
                }
                n.checked = a;
                const t = ba(null, "_chk", v, null, [ a ]);
                if (e && Vs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Os(n, "q-e:input", t) || c;
                }
                c = Os(n, "q-e:input", t) || c;
            } else if (f) {
                n && Vs.call(n, Fs) && delete n[Fs];
                if (e && Vs.call(e, Fs)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Fs];
                }
                n.value = f;
                const t = ba(null, "_val", m, null, [ f ]);
                if (e && Vs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Os(n, "q-e:input", t) || c;
                }
                c = Os(n, "q-e:input", t) || c;
            }
        }
        if (n && Vs.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && Vs.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Cs(t, n, e, s, o, r, c || !0, i);
};

const Js = (t, n, e, s) => Ks(t, n, s);

const Ys = (t, n, e, s, o) => Ks(t, {
    ...e,
    ...n
}, o);

const Gs = (t, n, e, s, o, r) => Ks(t, {
    ...e,
    ...n,
    children: s
}, r);

const Zs = t => t.children;

const Ks = (t, n, e, s, o) => Hs(t, n, null, null, 0, e, o);

const to = Ks;

const no = Ks;

function _(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Hs(t, n, null, s.children, 0, o);
}

const eo = t => t.children;

const ro = (t, n) => new Cs(Zs, null, null, t.children, 0, n);

const io = t => Qs(Zs, null, {
    [hr]: ""
}, t.children, 0, t.name ?? "");

const so = Symbol();

const oo = () => null;

const lo = () => null;

const uo = t => t.children;

const co = (t, n) => Ks(ro, {
    children: Ks(fo, t)
}, n);

const fo = () => null;

let ao = null;

let ho = null;

function g(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    ho || (ho = t.setAttributeNS);
                    ho.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            ao || (ao = t.setAttribute);
            ao.call(t, n, e);
        })(t, n, e);
    }
}

function E(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const po = Object.prototype.hasOwnProperty;

const $o = Object.prototype.propertyIsEnumerable;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

function k(t) {
    if (t) {
        for (const n in t) {
            if (S(n)) {
                return !0;
            }
        }
    }
    return !1;
}

const yo = (t, n = [], e = {}) => {
    if (!Ze(t) || !os(t)) {
        if (t == null) {
            throw new TypeError(`Cannot destructure '${t}' as it is ${t}.`);
        }
        const s = Object(t);
        const o = Reflect.ownKeys(s);
        for (let t = 0; t < o.length; t++) {
            const r = o[t];
            !$o.call(s, r) || typeof r !== "symbol" && n.includes(r) || Object.defineProperty(e, r, {
                value: s[r],
                enumerable: !0,
                configurable: !0,
                writable: !0
            });
        }
        return e;
    }
    let s = null;
    const o = t[Ui];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[Bi];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return y(new Cs(null, r, s, null, 0, null));
};

function R(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && po.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Ms) {
            return ta(n, t, ":", e);
        }
    }
    return es(n, "name") || "";
}

const wo = t => cr + t;

const mo = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + wo(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const vo = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const bo = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const _o = t => {
    if (!t) {
        return "";
    }
    if (tr(t)) {
        return t.trim();
    }
    const n = [];
    if (Ke(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = _o(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const go = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const Eo = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (Ke(t)) {
            throw er(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(go(e) + ":" + ko(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

const So = t => t != null ? t + "" : null;

function P(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = _o(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = Eo(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = So(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const ko = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => vo.has(t))(t)) {
        return n + "px";
    }
    return n;
};

class Ro {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Po {
    target;
    constructor(t) {
        this.target = t;
    }
}

class To {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class Ao {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class qo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Io = t => new Ro(t);

const Mo = t => new Po(t);

const No = (t, n) => new To(t, n);

const xo = (t, n, e) => new Ao(t, n, e);

const Co = (t, n, e, s = null, o = !1) => new qo(t, n, e, s, o);

const Oo = () => {
    const t = Jf();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Xr);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Xr, s);
    }
    let o = t.$.getHostProp(e, Dr);
    o === null && (o = 0);
    t.$.setHostProp(e, Dr, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const jo = t => {
    const n = nr(t) && !xa(t) ? je(void 0, t) : t;
    return Es(n);
};

const Lo = t => Fo(jo, t);

const Fo = (t, ...n) => {
    const {val: e, set: s} = Oo();
    if (e != null) {
        return e;
    }
    t = nr(t) && !xa(t) ? Gf(t, ...n) : t;
    return s(t);
};

function T(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    let e = null;
    let s = n;
    for (;s && !e; ) {
        e = I(s);
        s = s.slotParent || s.parent;
    }
    if (!e) {
        return;
    }
    const o = t.boundaries ||= [];
    if (!o.includes(e)) {
        o.push(e);
        e.value++;
    }
}

function A(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return $l(t, Hr, null) || null;
}

function q(t) {
    M(t, null);
}

function I(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return $l(t, Jr, null) || A(t);
}

function M(t, n) {
    __EXPERIMENTAL__.suspense && yl(t, Jr, n);
}

function N(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    M(t, n);
    const e = t.dirtyChildren;
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const s = e[t];
        N(s, A(s) || n);
    }
}

const Xo = t => {
    if (t.jn) {
        try {
            t.jn();
        } catch (t) {
            He(t);
        }
        t.jn = null;
    }
};

function x(n, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const t = Ie(s);
        return Vf(t, () => x(n, e, s, Yf(e, s, t)));
    }
    const r = o.$;
    const i = o._;
    bl(r, i);
    let c = n;
    if (i.flags & 64) {
        let t;
        if (!(i.flags & 128)) {
            t = !0;
            i.flags |= 128;
        }
        const o = t ? r.k : null;
        const l = $l(i, Wr, o);
        if (l !== null) {
            c = () => n(e, s, l);
        } else {
            const t = $l(i, Vr, o);
            t !== null && (c = () => n(e, s, ...t));
        }
    }
    return t(() => {
        if (!(i.flags & 32)) {
            return Le(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i, "event"));
}

function C(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Ie(n);
    return Vf(e, () => {
        const s = Yf(t, n, e);
        typeof this === "string" && $a(ya(s.$, this));
        const o = pa[0];
        return x(o, t, n, s);
    });
}

function O(t) {
    return t.R === t.T ? t.q : null;
}

function j(t) {
    return t.M || O(t);
}

function L(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = O(t);
    return e === o ? null : e;
}

const Do = Object.prototype.hasOwnProperty;

function F(t, n, e, s, o, r) {
    yl(n, e, r);
    vn(t, Co(n.node, e, s, o, (n.flags & 512) !== 0));
}

function X(t, n, e, s) {
    return {
        $: t,
        N: n,
        O: e,
        j: s,
        L: [],
        X: [],
        D: [],
        R: null,
        M: null,
        W: null,
        q: null,
        T: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: null,
        G: 0,
        Z: 0,
        K: !0,
        tt: !1,
        nt: {
            et: new Ns({
                j: s,
                rt: !0
            }),
            it: new Ns({
                j: s,
                rt: !1
            })
        }
    };
}

function D(t, n, e, s, o) {
    const r = t ?? X(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.N = e;
        t.O = s;
        t.j = o;
        t.nt.et.data.j = o;
        t.nt.it.data.j = o;
        t.X.length = 0;
        t.D.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Wo = (t, n, e, s, o, r, i) => W(D(i, t, n, o, r), e, s);

const Vo = (t, n, e, s, o, r, i, c, l = !1, u) => W(D(u, t, n, i, c), e, s, o, r, l);

function W(t, n, e, s = Ul(e), o = null, r = !1) {
    V(t, n, e, s, o, r);
    const i = K(t);
    if (fi(i)) {
        return i.finally(() => {
            tt(t);
        });
    }
    tt(t);
}

function V(t, n, e, s = Ul(e), o = null, r = !1) {
    const i = t.tt;
    t.tt = r || i;
    t.R = e;
    t.W = null;
    t.M = s;
    t.q = o;
    t.T = e;
    H(t, n, !0);
    try {
        if (t.R.flags & 32) {
            return;
        }
        for (;t.L.length; ) {
            for (;t.G < t.Z; ) {
                if (typeof t.Y === "string") {
                    vt(t, t.Y);
                } else if (typeof t.Y === "number") {
                    vt(t, t.Y + "");
                } else if (t.Y && typeof t.Y === "object") {
                    if (js(t.Y)) {
                        const n = t.Y.type;
                        if (typeof n === "string") {
                            rt(t);
                            at(t, t.Y, n);
                            const e = t.Y.constProps && Do.call(t.Y.constProps, Gr) || Do.call(t.Y.varProps, Gr);
                            e ? t.W || nt(t, !1) : B(t, t.Y.children, !0);
                        } else if (typeof n === "function") {
                            if (n === eo) {
                                rt(t);
                                $t(t, "F", t.Y.key);
                                B(t, t.Y.children, !0);
                            } else if (n === io) {
                                rt(t);
                                G(t) || B(t, t.Y.children, !0);
                            } else if (n === gt) {
                                Y(t);
                                B(t, t.Y.children, !0, !0);
                            } else if (n === lo) {
                                et(t);
                            } else if (n === oo) {
                                et(t);
                            } else {
                                rt(t);
                                yt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.Y)) {
                        B(t, t.Y, !1);
                    } else if (Su(t.Y)) {
                        $t(t, "S", null);
                        const n = t.Y instanceof Ms ? t.Y.st() : t.Y;
                        const e = t.M?.[yi]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Ms && (s = xt(e, n));
                        if (!s) {
                            const e = t.W || t.M;
                            B(t, z(t, () => ta(n, e, ".", t.$)), !0);
                        }
                    } else if (fi(t.Y)) {
                        $t(t, "A", null);
                        t.X.push(t.Y, t.W || t.M);
                    }
                } else {
                    t.Y === so || vt(t, "");
                }
                U(t);
            }
            et(t);
            Z(t);
            Q(t);
        }
    } finally {
        t.tt = i;
    }
}

function z(n, e) {
    try {
        return e();
    } catch (s) {
        if (fi(s)) {
            const o = s.then(() => t(e));
            n.X.push(o, n.W || n.M);
            return null;
        }
        throw s;
    }
}

function U(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.G++;
    if (t.G < t.Z) {
        t.Y = t.J[t.G];
    } else if (t.L.length > 0 && t.L[t.L.length - 1] === !1) {
        return Q(t);
    }
    t.W !== null ? t.W = null : t.M = L(t, t.M);
}

function B(t, n, e, s = !1) {
    if (!s && (n == null || e && Ke(n) && n.length === 0)) {
        nt(t);
        return;
    }
    H(t, n, e);
    if (e) {
        const n = !s && t.tt || !!t.W || !Ul(t.M);
        t.tt = n;
        t.H = null;
        t.U = null;
        t.B = null;
        t.R = t.W || t.M;
        t.M = Ul(t.R);
        t.W = null;
    }
    t.K = !1;
}

function Q(t) {
    const n = t.L.pop();
    if (n) {
        t.tt = t.L.pop();
        t.H = t.L.pop();
        t.U = t.L.pop();
        t.B = t.L.pop();
        t.W = t.L.pop();
        t.M = t.L.pop();
        t.R = t.L.pop();
    }
    t.Y = t.L.pop();
    t.Z = t.L.pop();
    t.G = t.L.pop();
    t.J = t.L.pop();
    U(t);
}

function H(t, n, e) {
    t.L.push(t.J, t.G, t.Z, t.Y);
    e && t.L.push(t.R, t.M, t.W, t.B, t.U, t.H, t.tt);
    t.L.push(e);
    if (Array.isArray(n)) {
        t.G = 0;
        t.Z = n.length;
        t.J = n;
        t.Y = t.Z > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.G = 0;
        t.Y = null;
        t.J = null;
        t.Z = 0;
    } else {
        t.G = 0;
        t.Y = n;
        t.J = null;
        t.Z = 1;
    }
}

function J(t) {
    if (t.W) {
        return j(t);
    }
    return L(t, t.M) || O(t);
}

function Y(t) {
    const n = t.Y;
    const e = n.key;
    t.M = $l(t.R, e, n => Sl(t.$.rootVNode, n));
    t.M = t.M && t.M.flags & 32 ? null : t.M;
    if (t.M == null) {
        t.W = ll();
        yl(t.W, fr, e);
        t.W.slotParent = t.R;
        yl(t.R, e, t.W);
    }
}

function G(t) {
    const n = t.Y;
    const e = mu(t.R);
    const s = R(e, n, t.$);
    const o = es(n, Hr) || null;
    const r = e ? $l(e, s, null) : null;
    if (r == null) {
        t.W = ll();
        yl(t.W, fr, s);
        yl(t.W, Hr, o);
        N(t.W, o);
        e && yl(e, s, t.W);
        jl(t.N, t.R, t.W, J(t));
        return !1;
    }
    if (r === t.M) {} else {
        const n = r.parent;
        t.W = r;
        yl(t.W, fr, s);
        yl(t.W, Hr, o);
        N(t.W, o);
        e && yl(e, s, t.W);
        Ol(t.N, t.W);
        jl(t.N, t.R, t.W, J(t));
        n && cl(n) && !n.firstChild && Wl(n) === qr && Xl(t.N, n.parent, n, !0);
    }
    return !0;
}

function Z(t) {
    const n = t.H;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            kt(t.$, t.N, e, t.O);
            Xl(t.N, t.R, e, !0);
        }
        n.clear();
        t.H = null;
    }
    t.M = null;
}

function K(t) {
    for (;t.X.length; ) {
        const n = t.X.shift();
        const e = t.X.shift();
        if (fi(n)) {
            return n.then(n => {
                V(t, n, e);
                return K(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return K(t);
            });
        }
        V(t, n, e);
    }
    if (t.D.length) {
        const n = t.D.splice(0);
        return Promise.all(n).then(() => K(t));
    }
}

function tt(t) {
    t.N = null;
    t.O = null;
}

function nt(t, n = !0) {
    const e = t.M && Ul(t.M);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            kt(t.$, t.N, s, t.O);
            s = s.nextSibling;
        }
        Dl(t.N, t.M, e, n);
    }
}

function et(t) {
    const n = O(t);
    if (t.M !== null && t.M !== n) {
        for (;t.M && t.M !== n; ) {
            const n = t.M;
            t.M = L(t, t.M);
            if (t.R === n.parent) {
                kt(t.$, t.N, n, t.O);
                Xl(t.N, t.R, n, !0);
            }
        }
    }
}

function rt(t) {
    if (t.M !== null && hl(t.M)) {
        const n = t.M;
        t.M = L(t, t.M);
        Xl(t.N, t.R, n, !0);
    }
}

function it(t, n, e) {
    if (Su(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw er(15, [ e ]);
}

function st(n, e, s, o, r) {
    return t(() => ta(o, e, s, n, r));
}

function ot(t, n, e, s, o) {
    const r = t.j;
    const i = s.then(t => g(n, e, P(e, t, r), o));
    t.D.push(i);
}

function lt(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Tr, "html");
    }
}

function ut(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ct(t, n, s, o) {
    const r = function i(t, n) {
        const s = Fl(t.R, !0);
        const o = e(s, n);
        const r = document;
        const i = o.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(o.elementNamespace, n);
        t.W = il(i, n);
        t.W.flags |= o.elementNamespaceFlag;
        return i;
    }(t, s);
    const c = t.W;
    const l = (c.flags & 512) !== 0;
    const {constProps: u} = n;
    if (u) {
        for (const n in u) {
            let e = u[n];
            if (Ti(n)) {
                ft(n, e, r, c, t);
                continue;
            }
            if (n === "ref" && it(e, r, o)) {
                continue;
            }
            Su(e) && (e = st(t.$, t.W, n, e, t.nt.et));
            if (fi(e)) {
                ot(t, r, n, e, l);
                continue;
            }
            if (n === Gr) {
                lt(r, e);
                continue;
            }
            if (s === "textarea" && n === "value" && ut(r, e)) {
                continue;
            }
            g(r, n, P(n, e, t.j), l);
        }
    }
    const f = n.key;
    f && (t.W.key = f);
    if (t.j) {
        const e = Do.call(n.varProps, "class") || n.constProps && Do.call(n.constProps, "class");
        e || r.setAttribute("class", t.j);
    }
    Il(t.N, t.R, t.W, j(t));
}

function ft(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = x.bind(null, n));
    }
    const i = r === "e:qvisible";
    (t.charAt(2) !== "e" || i) && wl(o.N, s, t, "");
    i || r === "d:qinit" || r === "d:qidle" ? a($(o.O), r) : ml(o.$, r);
}

function at(t, n, e) {
    if (t.tt) {
        ct(t, n, e, null);
    } else {
        const s = t.M && cl(t.M);
        const o = s && e === Wl(t.M);
        const r = n.key;
        const i = s && t.M.key;
        if (o && r === i) {
            dt(t, e, r);
        } else {
            const s = ht(e, r);
            pt(t, e, r, s, t.R) && ct(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.W || t.M;
    s && function r(t, n, e, s) {
        t.tt || bl(t.$, n);
        const o = n.props;
        const r = (n.flags & 1536) === 0;
        for (const i in e) {
            const c = e[i];
            const l = o && r && !Do.call(o, i) ? i.toLowerCase() : i;
            if (o && Do.call(o, l)) {
                const e = o[l];
                if (l !== i) {
                    yl(n, l, null);
                    yl(n, i, e);
                }
                At(c, e) || zo(t, n, i, c, s);
            } else {
                c != null && zo(t, n, i, c, s);
            }
        }
        if (o) {
            for (const r in o) {
                Do.call(e, r) || r.charAt(0) === ":" || Ti(r) || zo(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const zo = (t, n, e, s, o) => {
    if (Ti(e)) {
        ft(e, s, n.node, n, t);
        return;
    }
    if (e === Wr || e === Vr) {
        yl(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (it(s, t, o)) {
            return;
        }
    }
    const i = n[yi]?.get(e);
    if (Su(s)) {
        const o = s instanceof Ms ? s.st() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Tn(t.$, i);
        const r = n;
        s = st(t.$, r, e, o, t.nt.it);
    } else {
        i && Tn(t.$, i);
    }
    if (fi(s)) {
        const o = n;
        const i = s.then(n => {
            F(t.N, o, e, n, t.j, r);
        });
        t.D.push(i);
        return;
    }
    F(t.N, n, e, s, t.j, r);
};

function ht(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function dt(t, n, e) {
    const s = ht(n, e);
    if (s && t.H?.has(s)) {
        t.H.delete(s);
        return !0;
    }
    return !1;
}

function pt(t, n, e, s, o, r) {
    t.W = function i(t, n, e) {
        let s = null;
        if (t.U === null) {
            const o = t.M;
            if (o) {
                const s = cl(o) ? Wl(o) : null;
                const r = bt(o) || _t(o, t.$.k);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.U = new Map;
            t.B = [];
            const r = O(t);
            let i = t.M;
            for (;i && i !== r; ) {
                const o = cl(i) ? Wl(i) : null;
                const r = bt(i) || _t(i, t.$.k);
                s === null && r == e && o == n ? s = i : r === null ? t.B.push(o, i) : t.U.set(ht(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.B.length; e += 2) {
                if (t.B[e] === n) {
                    s = t.B[e + 1];
                    t.B.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ht(n, e);
            const r = t.U.get(o);
            if (r) {
                s = r;
                t.U.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.M) {
                    const n = cl(t.M) ? Wl(t.M) : null;
                    const e = bt(t.M) || _t(t.M, t.$.k);
                    if (e != null) {
                        const s = ht(n, e);
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                        t.U?.delete(s);
                    }
                }
                return;
            }
            const e = O(t);
            let s = t.M;
            for (;s && s !== n && s !== e; ) {
                const n = cl(s) ? Wl(s) : null;
                const e = bt(s) || _t(s, t.$.k);
                if (e != null) {
                    const o = ht(n, e);
                    t.H ||= new Map;
                    t.H.set(o, s);
                    t.U?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.W) {
        s || jl(t.N, o, t.W, j(t));
        t.M = t.W;
        t.W = null;
        return !1;
    }
    if (s != null) {
        const n = t.H?.get(s) || null;
        if (n) {
            t.H.delete(s);
            if (r && t.M) {
                const n = bt(t.M) || _t(t.M, t.$.k);
                if (n != null) {
                    const e = cl(t.M) ? Wl(t.M) : null;
                    const s = ht(e, n);
                    if (s != null) {
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                    }
                }
            }
            n !== t.M && jl(t.N, o, n, j(t));
            t.M = n;
            t.W = null;
            return !1;
        }
    }
    return !0;
}

function $t(t, n, e) {
    const s = n === "F";
    const o = bt(t.M);
    const r = t.M && dl(t.M);
    const i = r && o === e && (!s || !!e);
    if (i) {
        dt(t, null, o);
        return;
    }
    if (e === null || t.tt) {
        Ml(t.N, t.R, t.W = ll(), J(t));
        t.W.key = e;
        return;
    }
    if (pt(t, null, e, ht(null, e), t.R, !0)) {
        Ml(t.N, t.R, t.W = ll(), J(t));
        t.W.key = e;
    }
}

function yt(t, n) {
    const e = n[Na];
    let s = t.W || t.M;
    const o = t.Y;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.ot;
        const l = _t(s, t.$.k);
        const u = o.key || c;
        const f = bt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                dt(t, null, u);
            } else {
                wt(t, s, i, n);
                s = t.W;
                r = !0;
            }
        } else {
            if (pt(t, null, u, u, t.R)) {
                wt(t, s, i, n);
                r = !0;
            }
            s = t.W || t.M;
        }
        if (s) {
            const e = $l(s, Fr, t.$.k);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = Et(n[Ui], e[Ui], e[Hi], s, !1);
                        o ||= t;
                        const r = Et(n[Bi], e[Bi], e[Hi], s, !0);
                        o ||= r;
                        e[Qi] = n[Qi];
                    } else if (n) {
                        yl(t, Fr, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    wt(t, s, i, n);
                    s = t.W;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                yl(s, or, i);
                s.flags &= -33;
                mn(t.$, s, 4, t.O);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Cs(gt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            si(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (js(n) && es(n, fr) || "") + "";
                const i = ii(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            B(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = bt(s);
        const i = e === r;
        const c = _t(s, t.$.k);
        const l = c == null;
        if (s && !l || !s) {
            mt(t);
            s = t.W;
        } else if (i) {
            dt(t, null, e);
        } else {
            pt(t, null, e, e, t.R) && mt(t);
            s = t.W || t.M;
        }
        if (s) {
            let e = s;
            for (;e && (!dl(e) || $l(e, or, null) === null); ) {
                e = e.parent || mu(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[Vi] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            mn(t.$, s, 8, t.O);
        }
    }
}

function wt(t, n, e, s) {
    n && Pn(t.$, n);
    Ml(t.N, t.R, t.W = ll(), J(t));
    const o = t.Y;
    yl(t.W, or, e);
    yl(t.W, Fr, s);
    t.W.key = o.key;
}

function mt(t) {
    Ml(t.N, t.R, t.W = ll(), J(t));
    const n = t.Y;
    yl(t.W, Fr, n.props);
    n.key && (t.W.key = n.key);
}

function vt(t, n) {
    if (t.M !== null) {
        const e = yu(t.M);
        if (e === 3) {
            if (n !== Vl(t.M)) {
                zl(t.N, t.M, n);
                return;
            }
            return;
        }
    }
    Il(t.N, t.R, t.W = ol(document.createTextNode(n), n), j(t));
}

function bt(t) {
    if (t == null || hl(t)) {
        return null;
    }
    return t.key;
}

function _t(t, n) {
    if (t == null || hl(t)) {
        return null;
    }
    const e = $l(t, or, n);
    return e ? e.ot : $l(t, lr, null);
}

function gt() {}

function Et(t, n, e, s, o = !0) {
    if (St(t) && St(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === _r) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (n && i !== c && At(i, c)) {
                t[s] = c;
                continue;
            }
            if (!n || !At(i, c) && !qt(i, c)) {
                if (s === "class") {
                    if (Mt(i, c)) {
                        continue;
                    }
                } else if (s === "style" && It(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = ns(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === _r) {
                continue;
            }
            if ((!t || !Do.call(t, s)) && o) {
                delete n[s];
                const t = ns(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function St(t) {
    if (!t) {
        return !0;
    }
    return xs(t);
}

function kt(t, n, e, s = null) {
    let o = e;
    const r = s && $n(s) ? $(s) : null;
    if (hl(e)) {
        Tt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && $n(o) && u(t, r, o);
        const c = o.flags;
        if (c & 3) {
            Pn(t, o);
            Tt(o);
            const r = c & 2 && $l(o, or, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Xr);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (Ze(r)) {
                            const n = gu(r);
                            if (n) {
                                Pn(t, r);
                                if (r.h & 1) {
                                    r.h |= 16;
                                    mn(t, o, 128, s);
                                    continue;
                                }
                            } else {
                                (r instanceof $s || r instanceof Ms) && (r.h & 4 || Pn(t, r));
                            }
                            (n || r instanceof $s && (r.h & 512 || r.lt)) && Xo(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Sl(t.rootVNode, e) : e;
                                let c = Ul(o);
                                for (;c; ) {
                                    kt(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                Pt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = pl(o);
            if (i) {
                if (o === e) {
                    const n = Ul(o);
                    if (n) {
                        gn(n);
                        return;
                    }
                    Rt(t, o);
                }
            } else {
                const t = Ul(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Tt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function Rt(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, fr);
    e != null && t.getHostProp(n.slotParent, e) === n && yl(n.slotParent, e, null);
}

function Pt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && Wl(s) === qr) {
            Rt(t, e);
            Xl(n, s, e, !0);
        }
    }
}

function Tt(t) {
    t.flags |= 32;
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof Ms && n instanceof Ms && Nt(n, t);
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    if (Su(t) && Su(n)) {
        const e = t instanceof Ms ? t.st() : t;
        const s = n instanceof Ms ? n.st() : n;
        return Gf(() => e.value === s.value);
    }
    return !1;
}

function It(t, n) {
    if (t === n) {
        return !0;
    }
    return Eo(t) === Eo(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return _o(t) === _o(n);
}

function Nt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ut === t.ut && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ct, t.ct);
}

function xt(t, n) {
    if (!(n instanceof Ms)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Ms && Nt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Uo = (t, n, e, s, o) => {
    const r = Fe(t.fn, n, t);
    if (e) {
        r.hn = w(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, or));
    if (sr(s)) {
        o = o || t.getHostProp(n, Fr) || Zi;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (xa(s)) {
        const t = s;
        i = () => Le(r, t, [ o || Zi, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => Le(r, t, [ o || Zi ]);
    }
    const l = Ve;
    const u = (e = 0) => ai(() => {
        if (!c) {
            t.setHostProp(n, Dr, null);
            t.setHostProp(n, Br, null);
        }
        e > 0 && ul(n) && Pn(t, n);
        return hi(i(o), t => hi(r.dn, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < ci) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Ur);
        if (o) {
            return function r(t, n, e) {
                const s = Lt(n);
                let o = n;
                return hi(s, n => {
                    const s = !n;
                    let r = null;
                    for (const i in e) {
                        if (Object.prototype.hasOwnProperty.call(e, i)) {
                            let c = n;
                            let l = i;
                            if (s) {
                                if (i !== Or && !i.startsWith("q-d:") && !i.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    r = Xt();
                                    const n = Ve;
                                    n && t.ft(r) || (o = Ft(o, r));
                                }
                                c = r;
                            }
                            if (c) {
                                c.type === "script" && i === Or && (l = "q-d:qinit");
                                Ot(c, l, e[i]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (fi(t) && e < ci) {
            return t.then(() => u(++e));
        }
        if (e >= ci) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Ot(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Ii(n);
    c && jt(t, f, "capture");
    l && jt(t, f, "preventdefault");
    u && jt(t, f, "stoppropagation");
}

function jt(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === Zi && (t.varProps = {});
    t.varProps[s] = !0;
}

function Lt(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (js(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Ke(t)) {
            n.push(...t);
        } else {
            if (fi(t)) {
                return hi(t, t => Lt(t));
            }
            if (Su(t)) {
                return Lt(t.untrackedValue);
            }
        }
    }
    return null;
}

function Ft(t, n) {
    return Ke(t) ? [ ...t, n ] : [ t, n ];
}

function Xt() {
    return new Cs("script", null, {
        hidden: ""
    }, null, 0, ":useOn");
}

function Dt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Wt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Dt(t[c], c, r, s);
    }
    return i;
}

function Vt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function zt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Ul(e);
    const f = X(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Vo(c, n, Wt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        Dl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Vo(c, n, Wt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        Dl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const w = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== w; ) {
            const s = t.nextSibling;
            Xl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = w;
        return Vo(c, n, Wt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const m = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const _ = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < _.length; t++) {
        const s = _[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            Xl(n, e, s, !0);
        }
    }
    const S = new Int32Array(m);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < m; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(m);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let I = d;
    let A = w;
    const M = () => {
        for (;I >= h; ) {
            const t = I - h;
            if (P[t] === 1) {
                A = g[S[t]];
                I--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || jl(n, e, t, A);
                A = t;
                I--;
                continue;
            }
            let l = I;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = I - l + 1;
            const d = Vo(c, n, Wt(o, a, null, i, l, I), e, A, A, s, null, !0, f);
            return hi(d, () => {
                const t = Vt(e, A, u);
                A = t;
                I = l - 1;
                return M();
            });
        }
    };
    return M();
}

function Ut(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Xr);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof _u) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = bu(s, n, t);
                fi(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Bt(t, n) {
    const e = t.props ||= {};
    e[Xi] = n;
}

function Qt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[Di] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[Di] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = Al(n, document, r, e);
    const u = cl(r) && i || r;
    const f = u === r ? null : c;
    Il(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Ht(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Xi];
    }(t);
    if (!r) {
        return;
    }
    Bt(t, null);
    Su(r) && (r = r.value);
    return Wo(n, e, r, o, s, null);
}

function Jt(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, or);
    if (r && !r.resolved) {
        return r.resolve().catch(n => {
            t.dirty &= -5;
            throw n;
        });
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, Fr) || null;
    return Gt(n, o, o, r, i, e, s);
}

function Yt(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[Vi] || null;
        e && delete n[Vi];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Gt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Gt(n, e, s, o, r, i, c) {
    const l = ai(() => Uo(n, e, s, o, r), s => {
        const o = n.getHostProp(e, vr);
        return t(() => Wo(n, i, s, e, c, mo(o)));
    }, t => {
        n.handleError(t, e);
    });
    if (fi(l)) {
        return l;
    }
    return;
}

function Zt(t, n, e, s, o, r = null) {
    n.push(Co(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Kt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[Fi] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Su(e) && (e = e.value);
        const r = s.isConst;
        Zt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[Fi];
    })(t);
}

function tn(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Xr);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof _u && n.h & 16) {
            n.h &= -17;
            const t = n;
            Xo(t);
        }
    }
}

function nn(n, e) {
    n.dirty &= -33;
    const s = e.getHostProp(n, Wi);
    if (!s) {
        return;
    }
    const o = s.ht;
    const r = Xe();
    r.$ = e;
    return hi(t(() => je.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Au(e, s, o);
        }
    });
}

function en(t, n, e, s) {
    t.dirty &= -257;
    if (!__EXPERIMENTAL__.each) {
        return;
    }
    const o = t;
    const r = n.getHostProp(o, Fr) || null;
    if (!r) {
        return;
    }
    let i = rs(r, "items");
    Su(i) && (i = Gf(i));
    const c = rs(r, "key$");
    const l = rs(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return zt(n, e, o, s, i, u, f);
    }
    return hi(c.resolve(), t => hi(l.resolve(), r => zt(n, e, o, s, i, t, r)));
}

let Bo = null;

const Qo = (t, n, e) => {
    Bo || (Bo = t.insertBefore);
    Bo.call(t, n, e);
};

function rn(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const r = () => {
        if (s) {
            if (s.length === 1) {
                Qo(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                Qo(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let i = 0; i < t.length; i++) {
        const c = t[i];
        if (c instanceof Ao) {
            if (n === c.parent && e === c.beforeTarget) {
                s || (s = []);
                s.push(c.target);
                o.add(c.target);
                continue;
            }
            if (!s) {
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (n === c.parent) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (o.has(c.target) || e && c.target === e || n && c.target === n) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            Qo(c.parent, c.target, c.beforeTarget);
            continue;
        }
        if (c instanceof Ro) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            c.target.remove();
            continue;
        }
        if (c instanceof Po) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            const t = c.target;
            t.textContent = "";
            continue;
        }
        if (c instanceof To) {
            c.target.nodeValue = c.text;
        } else if (c instanceof qo) {
            const t = c.target;
            const e = c.attrName;
            const s = c.attrValue;
            const o = s != null ? P(e, s, c.scopedStyleIdPrefix) : null;
            const i = o == null || o === !1;
            if (Ho(t, e)) {
                t[e] = Jo(o);
            } else if (e === Gr) {
                n === t && r();
                t.innerHTML = o;
                t.setAttribute(Tr, "html");
            } else {
                i ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : g(t, e, o, c.isSvg);
            }
        }
    }
    r();
}

const Ho = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const Jo = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const Yo = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.jn = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const Go = (t => () => queueMicrotask(t))(ln);

const Ko = Yo(ln);

let tl = !1;

function sn() {
    if (!tl) {
        tl = !0;
        Go();
    }
}

function on() {
    if (!tl) {
        tl = !0;
        Ko();
    }
}

function ln() {
    tl = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = s(); ) {
        if (un(e, n)) {
            on();
            return;
        }
    }
}

function un(t, n) {
    const e = Ve;
    const s = $(t);
    const r = s.promise;
    if (r) {
        return;
    }
    const i = s.container;
    if (!t.dirty) {
        cn(i, t, s, e);
        return;
    }
    const c = s.journal ||= [];
    let u = null;
    for (;u = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(u.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && q(u);
            d(i, s, hn(u, t, i));
            continue;
        }
        if (u.flags & 32) {
            if (u.dirty & 128) {
                tn(u, i);
            } else if (u.dirty & 64) {
                const n = an(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            }
            u.dirty &= -1024;
            d(i, s, hn(u, t, i));
            continue;
        }
        let e;
        try {
            if (u.dirty & 1) {
                e = Ut(u, i, s);
            } else if (u.dirty & 2) {
                e = Ht(u, i, c, t);
            } else if (u.dirty & 4) {
                e = Jt(u, i, c, t);
            } else if (u.dirty & 8) {
                e = Yt(u, i, c, t);
            } else if (u.dirty & 256) {
                e = en(u, i, c, t);
            } else if (u.dirty & 16) {
                Kt(u, c);
            } else if (u.dirty & 32) {
                e = nn(u, i);
            } else if (u.dirty & 64) {
                const n = an(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            } else {
                u.dirty & 512 && Qt(u, c);
            }
        } catch (t) {
            i.handleError(t, u);
        }
        if (e && fi(e)) {
            T(s, u);
            const n = e;
            s.promise = n;
            o(t, i);
            const r = u;
            n.catch(t => {
                s.promise === n && i.handleError(t, r);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                l(t, i);
                sn();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    cn(i, t, s, e);
}

function cn(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        c(n, t);
        s || function o(t, n) {
            const e = $(t);
            const s = e.journal;
            if (s && s.length > 0) {
                rn(s);
                e.journal = null;
            }
            const o = h(e);
            if (o) {
                for (let t = 0; t < o.length; t++) {
                    ml(n, o[t]);
                }
            }
            (function r(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    bu(s, t, s.dt);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.value = Math.max(0, e.value - 1);
            }
        })(e);
        (function i(t) {
            __EXPERIMENTAL__.suspense && t.props && Hr in t.props && yl(t, Hr, null);
        })(n);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                fn(t);
            });
            return;
        }
        fn(t);
    }
}

function fn(t) {
    t.$t();
}

function an(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        q(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = hn(o[0], s, t);
    d(t, n, i);
    return i;
}

function hn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && dn(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && q(s);
    return hn(s, n, e);
}

function dn(t, n) {
    if (!A(n)) {
        return !1;
    }
    $n(n) || pn(t, n, 0);
    return !0;
}

function pn(t, n, e) {
    if ($n(n)) {
        sn();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        Li.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    i(t, r);
    sn();
    return r;
}

function $n(t) {
    return (t.flags & 256) !== 0;
}

function yn(t, n) {
    if (!(n.flags & 1)) {
        let e;
        n.dirty & 16 && function s(t, n) {
            n.dirty &= -17;
            const e = n.getProp(Fi);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Su(e) && (e = e.value);
                const r = P(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, r);
            }
        }(t, n);
        n.dirty & 32 && (e = nn(n, t));
        n.dirty &= -1024;
        return e;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Xr);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof _u) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = bu(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        fi(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            if (!__EXPERIMENTAL__.each) {
                return;
            }
            const e = n;
            const s = t.getHostProp(e, Fr) || null;
            if (!s) {
                return;
            }
            let o = rs(s, "items");
            Su(o) && (o = Gf(o));
            const r = await rs(s, "key$").resolve();
            const i = await rs(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const nl = [];

function wn(t) {
    for (let n = 0; n < nl.length; n++) {
        const e = nl[n];
        const s = nl[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function mn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return Ve;
    }()) {
        const e = yn(t, n);
        fi(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return e;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function t(n, e) {
            nl.push(n);
            let s = A(n);
            let o = n.slotParent || n.parent;
            for (;o; ) {
                const t = o.dirty & 1023;
                const r = $n(o);
                __EXPERIMENTAL__.suspense && (s ||= A(o) || (t ? I(o) : null));
                if (o === e || t) {
                    M(n, s);
                    wn(o);
                    if (r) {
                        const t = $(o);
                        t.position !== o && (t.position = n);
                    }
                    nl.length = 0;
                    return;
                }
                if (r) {
                    const t = $(o);
                    t.position !== o && (t.position = n);
                }
                nl.push(o);
                o = o.slotParent || o.parent;
            }
            nl.length = 0;
            ((t, ...n) => {
                const e = Ye(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        M(n, A(n) || I(c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if ($n(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = $(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        $n(n) ? M(n, A(n)) : function l(t) {
            nl.push(t);
            let n = A(t);
            let e = t.slotParent || t.parent;
            for (;e; ) {
                const s = $n(e);
                __EXPERIMENTAL__.suspense && (n ||= A(e) || (s ? I(e) : null));
                if (s) {
                    M(t, n);
                    wn(e);
                    nl.length = 0;
                    return !0;
                }
                nl.push(e);
                e = e.slotParent || e.parent;
            }
            M(t, n);
            nl.length = 0;
            return !1;
        }(n) || pn(t, n, 0);
    }
}

function vn(t, n) {
    t.push(n);
}

const el = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const rl = t => {
    let n = null;
    return e => {
        n || (n = el(e, t));
        return n.call(e);
    };
};

const il = (t, n, e = null) => {
    const s = new xi(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const sl = t => {
    const n = new xi(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const ol = (t, n) => {
    const e = new Ci(-4084, null, null, null, null, t, n);
    return e;
};

const ll = () => {
    const t = new Ni(null, -4094, null, null, null, null, null, null);
    return t;
};

const ul = t => t instanceof Mi;

const cl = t => (t.flags & 1) === 1;

const fl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const al = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const hl = t => (t.flags & 4) === 4;

const dl = t => (t.flags & 2) === 2;

const pl = t => {
    const n = t.flags;
    return (n & 2) === 2 && $l(t, fr, null) !== null;
};

const Sd = t => t;

const $l = (t, n, e) => {
    if (cl(t) || dl(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const yl = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const wl = (t, n, e, s, o = null) => {
    if (cl(n)) {
        yl(n, e, s);
        vn(t, Co(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const ml = (t, n) => {
    const e = window;
    e && (e._qwikEv ||= []).push(n);
};

const vl = t => {
    if (t.key) {
        return;
    }
    const n = Yl(t.node, Yr);
    n && (t.key = n);
};

const bl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (Ti(c)) {
                bn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== Yr && c) {
                if (c.startsWith(Tr)) {
                    const t = i.value;
                    t === "html" ? yl(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && yl(e, "value", s.value);
                } else {
                    const t = i.value;
                    yl(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        $l(e, Wr, null) === null && $l(e, Vr, null) === null || (n.flags |= 64);
    }
};

const _l = t => {
    if (t.gt === "_run") {
        const n = t.getCaptured()?.[0];
        if (sr(n)) {
            return n;
        }
    }
    return t;
};

function bn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = _l(Xn(i[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function _n(t, n, e) {
    let s = Ul(n);
    for (;s; ) {
        if (hl(s)) {
            El(t, s);
            e(s, n);
        } else {
            cl(s) ? e(s, n) : _n(t, s, e);
        }
        s = s.nextSibling;
    }
}

function gn(t) {
    let n = t;
    if (hl(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Ul(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const gl = (t, n, e) => {
    let s = t;
    for (;e && s && dl(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !dl(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !dl(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (hl(t) && e && cl(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && hu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const El = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Ll(n, !0);
        const o = e.node;
        const r = ou(s);
        let i = gl(n, !1, !0);
        const c = gl(n, !0, !0);
        const l = o || (c && cl(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && hl(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                vn(t, xo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = gl(i, !1, !0);
        }
        i = n;
        for (;i && hl(i); ) {
            const n = gl(i, !0, !0);
            const e = !n || !hl(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    vn(t, No(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    vn(t, xo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Sl = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = sl(i);
            vl(e);
            t.vNode = e;
            return e;
        }
    }
    if (ul(i)) {
        e = i;
    } else {
        if (__EXPERIMENTAL__.suspense && i._qSegment) {
            e = i.vNode || sl(i);
            vl(e);
        } else {
            let t = i;
            const n = [ i ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = Pl(e, n[t]);
            }
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = Tl(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = kl(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const kl = (t, n) => {
    let e = Ul(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Rl = [];

const Pl = (t, n) => {
    let e = Ul(t);
    for (;e && (!(e instanceof xi) || e.node !== n); ) {
        if (dl(e)) {
            const t = e.nextSibling;
            const n = Ul(e);
            if (n) {
                t && Rl.push(t);
                e = n;
            } else {
                e = t || (Rl.length ? Rl.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Rl.pop();
        }
    }
    for (;Rl.length; ) {
        Rl.pop();
    }
    return e;
};

const Tl = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Al = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = il(o, "errored-host");
    if (fl(e)) {
        jl(t, r, e, null);
    } else {
        const n = [];
        _n(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            jl(t, r, n[e], null);
        }
    }
    return r;
};

const ql = rn;

const Il = (t, n, e, s) => {
    const o = cl(n);
    o && Bl(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Cl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Ll(n, !1);
    l && !c && vn(t, xo(i, l, Nl(t, n, s)?.node ?? null));
    xl(n, e, s);
    c && (e.flags |= 32);
};

const Ml = (t, s, o, r) => {
    const i = cl(s);
    i && Bl(s);
    const c = o.parent;
    if (o === r) {
        if (c) {
            return;
        }
        r = null;
    }
    Cl(t, c, s, o);
    const l = s.flags & 32;
    const u = !i && s.flags & 2048 ? s.props?.[ur] : null;
    const f = u ? null : i ? s : Fl(s, !1);
    const a = u || f?.node;
    const h = Nl(t, s, r);
    const d = h?.node ?? null;
    const p = pl(o);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = Fl(s, !1);
        const c = Nl(t, s, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = e(i, o);
        _n(t, o, s => {
            if (hl(s)) {
                vn(t, xo(s.node, a, c));
            } else {
                if ((s.flags & 1536) !== u) {
                    const t = function o(t, s, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let o = null;
                            let a = null;
                            if (cl(c)) {
                                o = c.node;
                                const t = Wl(c);
                                const l = c.parent;
                                const h = u == null ? s : l && Fl(l, !0);
                                if (h) {
                                    const t = e(h, Wl(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = Ul(c);
                                a = n(o, t, r, !d);
                                o.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (Hl(o)) {
                                    const t = Me(o);
                                    if (t) {
                                        const n = Ul(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(s, i, l, u);
                    t && (s.node = t);
                }
                vn(t, xo(s.node, a, c));
            }
        });
    } else {
        a && !l && _n(t, o, n => {
            vn(t, xo(n.node, a, d));
        });
    }
    xl(s, o, r);
    l && (o.flags |= 32);
};

const Nl = (t, n, e) => {
    let s = null;
    e == null ? dl(n) && (s = gl(n, !0, !1)) : s = dl(e) ? gl(e, !0, !0) : e;
    s && hl(s) && El(t, s);
    return s;
};

const xl = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Cl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && Xl(t, n, s, !1);
};

const Ol = (t, n) => {
    let e = n;
    for (;e && dl(e); ) {
        e = e.lastChild;
    }
    e && hl(e) && (e.flags & 8) === 0 && El(t, e);
};

const jl = (t, n, e, s) => {
    fl(e) ? Il(t, n, e, s) : Ml(t, n, e, s);
};

const Ll = (t, n) => {
    for (;t && !cl(t); ) {
        if (t.flags & 2048) {
            return t.props?.[ur];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Fl = (t, n) => {
    for (;t && !cl(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const Xl = (t, n, e, s) => {
    hl(e) && El(t, e);
    if (s) {
        const s = $l(n, Gr, null) !== null;
        if (s) {
            return;
        }
        fl(e) ? vn(t, Io(e.node)) : _n(t, e, n => {
            vn(t, Io(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const Dl = (t, n, e, s = !0) => {
    const o = Ll(n, !0);
    if (o && s) {
        if (fl(n)) {
            vn(t, Mo(n.node));
        } else {
            const e = Fl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? vn(t, Mo(o)) : _n(t, n, n => {
                vn(t, Io(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const Wl = t => {
    const n = Sd(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = su(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = iu(t);
            switch (n) {
              case Nr:
                return 512;

              case xr:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Vl = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const zl = (t, n, e) => {
    El(t, n);
    n.text = e;
    vn(t, No(n.node, e));
};

const Ul = t => {
    if (hl(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && cl(t) && function e(t) {
        const n = t.getAttribute(_d);
        if (n === null) {
            return !1;
        }
        const e = ru(t);
        return wu(e) && e.localName === "template" && e.getAttribute(pr) === n && tu(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = Bl(t));
    return n;
};

const Bl = t => {
    const n = Sd(t);
    let e = n.firstChild;
    if (e === void 0) {
        const t = n.node;
        e = n.parent && Hl(t) ? n.firstChild = n.lastChild = null : (t => {
            const n = t.node;
            const e = ru(n);
            const s = ou(n)?.qVNodeData?.get(n);
            const o = ((t, n, e, s) => {
                vl(t);
                __EXPERIMENTAL__.suspense && n._qSegment;
                if (s) {
                    if (s.charCodeAt(0) === gi && s.charCodeAt(1) === gi) {
                        const n = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(s);
                        const o = n.elementVNodeData;
                        s = n.virtualVNodeData;
                        const r = lu(t, e, o);
                        if (!s) {
                            return r;
                        }
                    }
                    return function o(t, n, e, s) {
                        let o = 0;
                        let r = null;
                        let i = null;
                        let c = null;
                        const l = n => {
                            n.flags = n.flags & 4095 | o << 12;
                            o++;
                            i && (i.nextSibling = n);
                            n.previousSibling = i;
                            n.parent = t;
                            r || (t.firstChild = r = n);
                            i = n;
                        };
                        let u = 0;
                        let f = null;
                        let a = null;
                        const h = t => {
                            const n = wu(t);
                            return !n || n && Rn(t);
                        };
                        let d = null;
                        uu(n, (p, $, y, w, m, b) => {
                            if (du(p())) {
                                for (;h(s); ) {
                                    s = tu(s);
                                    if (!s) {
                                        throw er(27, [ n, p(), m ]);
                                    }
                                }
                                f = null;
                                c = null;
                                let t = 0;
                                for (;du(p()); ) {
                                    t *= 10;
                                    t += y() - 48;
                                }
                                for (;t--; ) {
                                    const e = sl(s);
                                    vl(e);
                                    l(e);
                                    s = tu(s);
                                    for (;wu(s) && Rn(s); ) {
                                        s = tu(s);
                                        if (!s && t > 0) {
                                            throw er(27, [ n, p(), m ]);
                                        }
                                    }
                                }
                            } else if (p() === 59) {
                                yl(t, vr, $());
                            } else if (p() === 60) {
                                const n = $();
                                if (n.charCodeAt(0) === 95) {
                                    yl(t, lr, decodeURIComponent(E(n.slice(1))));
                                } else {
                                    (d ||= []).push(t);
                                    yl(t, or, n);
                                }
                            } else if (p() === 61) {
                                a || (a = Ie(e));
                                const n = $();
                                a.Xn(parseInt(n, 10), t);
                            } else if (p() === 62) {
                                yl(t, Fr, $());
                            } else if (p() === 64) {
                                t.key = b();
                            } else if (p() === 91) {
                                yl(t, Xr, $());
                            } else if (p() === 94) {
                                yl(t, Dr, $());
                            } else if (p() === 96) {
                                a || (a = Ie(e));
                                Sn(t, $(), a);
                            } else if (p() === 63) {
                                a || (a = Ie(e));
                                t.slotParent = Sl(a.rootVNode, $());
                            } else if (p() === 93) {
                                yl(t, br, $());
                            } else if (p() === 123) {
                                y();
                                l(ll());
                                $u.push(t, r, i, c, o);
                                o = 0;
                                t = i;
                                r = i = null;
                            } else if (p() === gi) {
                                const n = $();
                                const e = decodeURIComponent(E(n));
                                const s = m + n.length + 1;
                                const o = w(s + 1) === gi;
                                let r;
                                if (o) {
                                    y();
                                    r = decodeURI(E($()));
                                    y();
                                } else {
                                    r = E($());
                                }
                                yl(t, e, r);
                            } else if (p() === 125) {
                                y();
                                t.lastChild = i;
                                o = $u.pop();
                                c = $u.pop();
                                i = $u.pop();
                                r = $u.pop();
                                t = $u.pop();
                            } else if (p() === 126) {
                                yl(t, fr, b());
                            } else {
                                for (;wu(s) && Rn(s); ) {
                                    s = tu(s);
                                }
                                const t = s && Gl(s) === 3 ? s : null;
                                if (f === null) {
                                    f = t ? t.nodeValue : null;
                                    u = 0;
                                }
                                let n = 0;
                                for (;pu(p()); ) {
                                    n += y() - 97;
                                    n *= 26;
                                }
                                n += y() - 65;
                                const e = f === null ? "" : f.substring(u, u + n);
                                l(c = ((t, n, e) => {
                                    const s = new Ci(-4092, null, t, null, null, n, e);
                                    return s;
                                })(c, t, e));
                                u += n;
                            }
                        });
                        if (d) {
                            a || (a = Ie(e));
                            for (let t = 0; t < d.length; t++) {
                                a.ensureProjectionResolved(d[t]);
                            }
                            d = null;
                        }
                        t.lastChild = i;
                        return r;
                    }(t, s, n, e);
                }
                return lu(t, e, void 0);
            })(t, n, e, s);
            return o;
        })(n);
    }
    return e;
};

let Ql = null;

const Hl = t => {
    Ql || (Ql = t.hasAttribute);
    return Ql.call(t, Tr);
};

let Jl = null;

const Yl = (t, n) => {
    Jl || (Jl = t.getAttribute);
    return Jl.call(t, n);
};

const Gl = rl("nodeType");

const Zl = t => {
    const n = Gl(t);
    return n === 3 || n === 1;
};

let Kl = null;

const tu = t => {
    Kl || (Kl = el(t, "nextSibling"));
    eu || (eu = el(t, "firstChild"));
    for (;t; ) {
        t = Kl.call(t);
        if (t !== null) {
            const n = Gl(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(Rr)) {
                    return En(t, Sr, Kl, eu);
                }
                if (t.nodeValue?.startsWith(kr)) {
                    return En(t, [ Sr, Pr ], Kl, eu);
                }
                if (n?.startsWith(Tr)) {
                    for (;t && (t = Kl.call(t)) && (Gl(t) !== 8 || !t.nodeValue?.startsWith(Ar)); ) {}
                }
            }
        }
    }
    return t;
};

function En(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = nu(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const nu = rl("parentNode");

let eu = null;

const ru = t => {
    eu || (eu = el(t, "firstChild"));
    t = t && eu.call(t);
    if (t && Gl(t) === 8) {
        Kl || (Kl = el(t, "nextSibling"));
        if (t.nodeValue?.startsWith(Rr)) {
            return En(t, Sr, Kl, eu);
        }
    }
    for (;t && !Zl(t); ) {
        t = tu(t);
    }
    return t;
};

const iu = rl("namespaceURI");

const su = rl("nodeName");

const ou = rl("ownerDocument");

const lu = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;wu(i) && Rn(i); ) {
            i = tu(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = Gl(i);
        let e = null;
        if (n === 3) {
            e = ol(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = sl(i);
            vl(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = tu(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        uu(e, (e, s) => {
            if (e() === 61) {
                n || (n = Ie(t.node));
                const e = s();
                n.Xn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = Ie(t.node));
                Sn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function Sn(t, n, e) {
    if (t[yi]) {
        const s = t[yi];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e.k(n));
    } else {
        Object.defineProperty(t, yi, {
            get() {
                const s = e.k(n);
                t[yi] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, yi, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const uu = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    const u = () => {
        if (r(e + 1) !== gi) {
            return l();
        }
        c();
        const t = decodeURIComponent(E(l()));
        c();
        return t;
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e, u);
    }
};

const cu = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        bl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(Yr) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const fu = (t, n) => {
    let e = au(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = au(e);
    }
    return !1;
};

const au = t => t.parent || t.slotParent;

const hu = t => {
    if (t === null || dl(t)) {
        return null;
    }
    return t.node;
};

function kn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (cl(e)) {
                        const t = Ne(e.node);
                        if (!t) {
                            return null;
                        }
                        return Me(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (hl(i)) {
            c.push(Nn(Vl(i)));
        } else if (dl(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = cu(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== mi && e !== "__scopedStyleIdPrefix__") {
                        const t = $l(i, e, null);
                        s.push(" " + e + "=" + Nn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (vi[$l(i, mi, null) || "V"] || vi.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Ul(i);
            u && c.push("  " + kn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (cl(i)) {
            const s = Wl(i);
            const l = [];
            $n(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? cu(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = $l(i, n, null);
                l.push(" " + n + "=" + Nn(e));
            }
            const f = hu(i);
            if (f) {
                const t = ou(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + Nn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + Nn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (al(i) || e) {
                const e = Ul(i);
                e && c.push("  " + kn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const du = t => 48 <= t && t <= 57;

const pu = t => 97 <= t && t <= 122;

function Rn(t) {
    return !t.hasAttribute(Yr) || t.nodeName === "STYLE" && (t.hasAttribute(vr) || t.hasAttribute(yr));
}

const $u = [];

const yu = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw er(26, [ n ]);
};

const wu = t => t && typeof t == "object" && Gl(t) === 1;

const mu = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!dl(t) || $l(t, or, null) === null); ) {
            const e = t.slotParent;
            const s = dl(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function Pn(t, n) {
    ul(n) && cl(n) && Bl(n);
    const e = n[yi];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Tn(t, n);
    }
    e.clear();
}

function Tn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof ds) {
            An(t, s, n);
            s instanceof $s && qn(s, n);
        } else if (os(s)) {
            const t = s[Hi];
            In(t, n);
        } else if (t.yt.has(s)) {
            const e = t.yt.get(s);
            const o = Cu(e);
            In(o, n);
        }
    }
    e.clear();
}

function An(t, n, e) {
    const s = n.ht;
    s && s.has(e) && s.delete(e);
    if (n instanceof Ms && !s?.size) {
        n._ = void 0;
        Pn(t, n);
    }
}

function qn(t, n) {
    const e = t.wt;
    e && e.has(n) && e.delete(n);
    const s = t.vt;
    s && s.has(n) && s.delete(n);
    t.bt();
}

function In(t, n) {
    const e = t?.ht;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const vu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Oo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new _u(6 | i, r, o._, t, null);
    s(c);
    const l = o.$;
    const {dn: u} = o;
    const f = hi(u, () => bu(c, l, o._));
    fi(f) && (o.dn = f);
};

const bu = (t, n, e) => {
    const s = t.Dn;
    if (s) {
        return s;
    }
    t.h = t.h & -5 | 64;
    const o = t => {
        Nf(t, "hook");
        n.handleError(t, e, "hook");
    };
    let r = null;
    const i = hi(((t, n) => {
        const e = t.Wn;
        if (e) {
            return e;
        }
        const s = t.jn;
        if (!s) {
            return;
        }
        t.jn = null;
        try {
            const e = s();
            if (fi(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Wn === s && (t.Wn = void 0);
                });
                t.Wn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = Xe(n.fn, e, "qTask");
        s.$ = n;
        const i = t._t.getFn(s, () => Pn(n, t));
        const c = hs(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.jn = () => {
                            t.jn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    fi(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return ai(() => i(u), l, s => {
            if (fi(s)) {
                return s.then(() => {
                    t.Dn === r && (t.Dn = null);
                    return bu(t, n, e);
                }, o);
            }
            o(s);
        });
    });
    if (fi(i)) {
        r = i.finally(() => {
            t.Dn === r && (t.Dn = null);
        });
        t.Dn = r;
        return r;
    }
    return i;
};

class _u extends wi {
    h;
    Xt;
    dt;
    _t;
    jn;
    Wn;
    Dn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Xt = n;
        this.dt = e;
        this._t = s;
        this.jn = o;
    }
}

const gu = t => t instanceof _u;

function Mn(t, n) {
    const e = Ie(n);
    return Vf(e, () => {
        typeof this === "string" && $a(ya(e, this));
        const t = pa[0];
        if (!t.dt) {
            return;
        }
        if (t.h & 68) {
            return;
        }
        t.h |= 4;
        mn(e, t.dt, 1);
    });
}

const Eu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Su = t => t instanceof ds;

const ku = (t, n) => {
    t.add(n);
};

const Ru = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Pu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        gu(e) ? o = e._t : e instanceof $s ? o = e.Wt : s === ":" && (o = n.getHostProp(e, or));
        o && n.serializationCtx.Ft.add(o);
    }
};

const Tu = (t, n) => {
    if (t && (!n || t === n || Ed(t))) {
        return t;
    }
    return n;
};

const Au = (t, n, e) => {
    const s = ze;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (gu(o)) {
                o.h |= 4;
                mn(t, o.dt, 1);
            } else if (o instanceof ds) {
                o.invalidate();
            } else if (r === ":") {
                mn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Bt(o, n);
                    mn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Ns) {
                    const e = i.data;
                    const c = {
                        isConst: e.rt,
                        scopedStyleIdPrefix: e.j,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[Fi];
                            if (!o) {
                                o = new Map;
                                s[Fi] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(Fi);
                        if (!n) {
                            n = new Map;
                            t.setProp(Fi, n);
                        }
                        n.set(r, c);
                    }
                    mn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const qu = t => Ze(t) && typeof t[yf] === "function";

const Iu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Mu = t => {
    t.h |= 4;
};

const Nu = [];

function Nn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (gu(t)) {
            return `Task(${Nn(t._t)})`;
        }
        if (sr(t)) {
            return `Qrl(${t.gt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Nu.includes(t)) {
                return "*";
            }
            Nu.length;
            try {
                Nu.push(t);
                if (Array.isArray(t)) {
                    return ul(t) ? "(" + ($l(t, mi, null) || "vnode") + ")" : t.map(Nn);
                }
                if (Su(t)) {
                    return t instanceof Ms ? "WrappedSignal" : t instanceof $s ? "ComputedSignal" : "Signal";
                }
                if (Xu(t)) {
                    return "Store";
                }
                if (js(t)) {
                    return xu(t);
                }
                if (ul(t)) {
                    return "(" + ($l(t, mi, null) || "vnode") + ")";
                }
            } finally {
                Nu.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const xu = t => {
    if (js(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Na];
            if (n) {
                const [t] = n;
                return "Component(" + t.gt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + Nn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += xu(e);
                    }
                } else {
                    n += xu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Cu = t => t[fs];

const Ou = t => {
    try {
        return t?.[cs] || null;
    } catch {
        return null;
    }
};

const ju = (t, n) => {
    const e = Cu(t);
    e && e.force(n);
};

const Lu = (t, n) => {
    const e = Cu(t);
    if (e) {
        return (e.ht?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Fu = t => Ou(t) || t;

const Xu = t => cs in t;

function xn(t, n, e) {
    return new Proxy(n, new Wu(e, t || null));
}

const Du = (t, n, e) => {
    if (Ge(t) && e) {
        let s = e.yt.get(t);
        if (!s) {
            s = xn(e, t, n);
            e.yt.set(t, s);
        }
        return s;
    }
    return t;
};

class Wu {
    h;
    $;
    ht=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Ou(this);
        Au(this.$, this, jn(n, t, this.ht));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === cs) {
                return t;
            }
            if (n === fs) {
                return this;
            }
            return t[n];
        }
        const e = Qf();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.hn;
            o && Cn(t, Array.isArray(t) ? as : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        let r = !1;
        if (o & 1 && Ze(s)) {
            try {
                r = !Object.isFrozen(s) && !Xu(s) && !Object.isFrozen(t);
            } catch {}
        }
        if (r) {
            return Du(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Fu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && On(n, s, t, this);
        } else {
            On(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Au(this.$, this, jn(t, n, this.ht));
        return !0;
    }
    has(t, n) {
        if (n === cs) {
            return !0;
        }
        if (typeof n === "string") {
            const e = Qf();
            if (e) {
                const s = e.hn;
                s && Cn(t, Array.isArray(t) ? as : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = Qf();
        const e = n?.hn;
        e && Cn(t, as, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function Cn(t, n, e, s, o) {
    const r = e.ht ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = Ve;
    const l = __EXPERIMENTAL__.suspense && e instanceof Wu && c;
    ku(i, s);
    Ru(s, t);
    if (c) {
        const i = Tu(o, e.$);
        l && i?.wn?.(t, s, n, r);
        Pu(s, i);
    }
}

function On(t, n, e, s) {
    e[t] = n;
    const o = jn(e, t, s.ht);
    o && Au(s.$, s, o);
}

function jn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(as);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Vu = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const zu = '"';

const Uu = "[";

const Bu = "]";

const Qu = ",";

const Hu = Symbol();

const Ju = [ void 0, null, !0, !1, "", Gi, Zi, ls, as, Yi, io, eo, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const Yu = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const Gu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function Ln(t, n, e) {
    let s = n.gt;
    let o = n.Et;
    const r = ri();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => sr(t) && t.gt == ir)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.St(null, 0, e) + "";
    } else {
        o || (o = t.kt(n.ot));
        if (!o) {
            throw er(14, [ n.gt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.Rt(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function Fn(t, n, e, s) {
    return ba(t, n, null, null, e, s);
}

function Xn(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return Fn(o, r, i, n);
}

class Zu {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class Ku {
    Vn;
    zn=0;
    Tt=[];
    Un=0;
    Bn=new Set;
    Qn=new Map;
    Hn;
    Jn=new Map;
    Yn=0;
    Yt;
    Gn=typeof Temporal !== "undefined";
    constructor(t) {
        this.Vn = t;
        this.Yt = t.Yt;
    }
    async serialize() {
        const t = this.Yn;
        this.Yn = 0;
        try {
            await this.outputRoots();
        } finally {
            this.Yn = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.Yn;
        this.Yn = s;
        this.Yt.write(Uu);
        this.Vn.Zn = 0;
        try {
            this.Yt.write(t + "");
            this.Yt.write(Qu);
            this.Yt.write(Uu);
            await this.outputSelectedRoots(n);
            this.Yt.write(Bu);
            const s = this.getForwardRefsPayload();
            this.Vn.Zn = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Yt.write(Qu);
                s ? this.outputForwardRefsArray(s) : this.Yt.write("0");
            }
            if (e !== void 0) {
                this.Yt.write(Qu);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Yt.write(zu);
                    this.writeRootRefPath(e);
                    this.Yt.write(zu);
                }
            }
        } finally {
            this.Yn = o;
        }
        this.Yt.write(Bu);
    }
    Kn(t) {
        this.Yt = t;
    }
    outputArray(t, n, e) {
        this.Yt.write(Uu);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Yt.write(Qu) : s = !0;
            e(t[n], n);
        }
        this.Yt.write(Bu);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : zu + t + zu;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Yt.write(n.slice(s, e));
            this.Yt.write("<\\/");
            s = e + 2;
        }
        this.Yt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Yt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Yt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Yt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Yt.write(zu);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Yt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Yt.write(zu);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Yt.write(t + Qu);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Yt.write(zu);
                this.writeRootRefPath(n);
                this.Yt.write(zu);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Yt.write(t + Qu);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Yt.write(t + Qu + n);
        } else if (typeof n === "string") {
            this.Yt.write(t + Qu);
            this.outputString(n);
        } else {
            this.Yt.write(t + Qu);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Vn.getSeenRef(t);
        const o = !e && this.Qn.get(t);
        if (s) {
            s.Hn && this.isSeenInStreamedRoot(s) && (s = this.Vn.te(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Vn.ne(t, this.Hn, n);
            }
            s = this.Vn.Rt(t, !0);
        }
        if (s.Hn) {
            if (this.Hn) {
                this.Vn.ee(s, t);
            } else {
                this.Vn.ee(s, t, n);
                t = this.Vn.re[n];
            }
        }
        if (typeof o === "number") {
            this.Tt[o] = s.Xt;
            this.Qn.delete(t);
        }
        const r = t instanceof cc ? t.ie : s.Xt;
        if (!this.Hn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.Hn; ) {
            t = t.Hn;
        }
        return t.Xt < this.Yn;
    }
    writeValue(t, n) {
        if (df(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === ls) {
                    this.output(3, 7);
                } else if (t === as) {
                    this.output(3, 8);
                } else if (t === Yi) {
                    this.output(3, 9);
                } else {
                    if (t !== Hu) {
                        throw er(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === io) {
                    this.output(3, 10);
                } else if (t === eo) {
                    this.output(3, 11);
                } else if (sr(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = Ln(this.Vn, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.Vn.Rt(n);
                            const i = this.Vn.Rt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.Jn.get(l);
                            if (u) {
                                const t = this.Vn.Rt(u);
                                this.output(1, t);
                                return;
                            }
                            this.Jn.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!xa(t)) {
                        throw er(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[Na];
                        this.Vn.se.add(n.gt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Gi) {
                    this.output(3, 5);
                } else if (t === Zi) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof cc) {
                    this.output(1, t.ie);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.Hn;
                        this.Hn = e;
                        this.writeObjectValue(t);
                        this.Hn = n;
                    }
                }
                break;

              default:
                throw er(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (os(t)) {
            const n = t[Qi];
            this.output(38, [ lc(n), n.varProps, n.constProps, t[Hi].ht ]);
        } else if (t instanceof Ns) {
            const {j: n, rt: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof us) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof Zu) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (Xu(t)) {
            const n = Cu(t);
            const e = Ou(t);
            const s = n.h;
            const o = n.ht;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Vn.yt.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (qu(t)) {
            const n = t[yf](t);
            if (fi(n)) {
                const t = this.resolvePromise(n, (t, n) => new tc(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.Hn.Xt;
                this.Hn = this.Hn.Hn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        df(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Vn.oe(t)) {
            this.Vn.le(t.ue, 16);
            this.output(11, t.ue.id);
        } else if (t instanceof ds) {
            if (t instanceof ws) {
                const n = function e(t, n) {
                    if (n === ls) {
                        return n;
                    }
                    return hi(t.Wt.resolved || t.Wt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && yf in n && (e = n[yf](n));
                        e === void 0 && (e = ls);
                        return e;
                    });
                }(t, t.Dt);
                if (fi(n)) {
                    const e = this.resolvePromise(n, (n, e) => new tc(34, n, e, t.ht, t.Wt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Wt, t.ht, n ]);
                }
                return;
            }
            if (t instanceof Ms) {
                this.output(31, [ ...Dn(this.Vn, t), t.h, t._, ...t.ht || [] ]);
            } else if (t instanceof $s) {
                let n = t.Dt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = df(t.Dt);
                const i = !!(t.h & 512);
                const c = i && !!t.Vt;
                const l = i && t.Ut !== 1 ? t.Ut : void 0;
                const u = i && t.Qt !== 0 ? t.Qt : void 0;
                const f = i && t.h & -25 || void 0;
                o || r || c ? n = ls : e ? n = t.Dt : s && (n = ls);
                const a = [ t.Wt, t.ht ];
                if (i) {
                    const n = t.Vt;
                    a.push(t.wt, t.vt, n === void 0 ? n : Rf(n));
                    a.push(f || void 0);
                }
                n === ls && l === void 0 && u === void 0 || a.push(n === void 0 ? Hu : n);
                if (i) {
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Dt;
                const e = [ n === void 0 ? Hu : n ];
                t.ht && e.push(...t.ht);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            for (const e of Object.entries(t)) {
                n.push(e[0], e[1]);
            }
            this.output(23, n);
        } else if (this.Vn.ce(t)) {
            if (t.vnodeData && t.vnodeData[0] & 32 && /[A-Za-z]/.test(t.id)) {
                this.output(3, 0);
                return;
            }
            const n = this.Vn.Rt(t);
            this.Vn.fe(t, jr, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                nc(e, this.Vn);
                this.Vn.le(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.Vn.le(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (js(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof _u) {
            const n = [ t._t, t.h, t.Xt, t.dt ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (fi(t)) {
            const n = this.resolvePromise(t, (t, n) => new tc(24, t, n));
            this.output(2, n);
        } else if (t instanceof tc) {
            if (t.ae === 34) {
                if (t._t) {
                    this.output(34, [ t._t, t.ht, t.he ]);
                } else {
                    if (!t.de) {
                        console.error(t.he);
                        throw er(33);
                    }
                    {
                        const n = this.Hn.Xt;
                        this.Hn = this.Hn.Hn;
                        this.writeValue(t.he, n);
                    }
                }
            } else {
                this.output(24, [ t.de, t.he ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof oc) {
            const n = t.pe;
            if (this.getSeenRefOrOutput(n, this.Hn.Xt, !0)) {
                let t = this.Qn.get(n);
                if (t === void 0) {
                    t = this.Un++;
                    this.Qn.set(n, t);
                    this.Tt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.Gn && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.Gn && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.Gn && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.Gn && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.Gn && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.Gn && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.Gn && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.Gn && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!ul(t)) {
                throw er(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Un++;
        t.then(s => {
            this.Bn.delete(t);
            this.Tt[e] = this.Vn.Rt(n(!0, s));
        }).catch(s => {
            this.Bn.delete(t);
            this.Tt[e] = this.Vn.Rt(n(!1, s));
        });
        this.Bn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Vn.$e + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {re: n} = this.Vn;
        for (;this.zn < n.length || this.Bn.size; ) {
            let e = t > 0;
            for (;this.zn < n.length; this.zn++) {
                e ? this.Yt.write(Qu) : e = !0;
                this.writeValue(n[this.zn], this.zn);
                t++;
            }
            if (this.Bn.size) {
                try {
                    await Promise.race(this.Bn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Bn.size; ) {
            if (e < t.length) {
                n ? this.Yt.write(Qu) : n = !0;
                const s = t[e++];
                this.writeValue(this.Vn.re[s], s);
                continue;
            }
            try {
                await Promise.race(this.Bn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Tt.length - 1;
        for (;t >= 0 && this.Tt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Tt.length - 1 ? this.Tt : this.Tt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Yt.write(zu);
                this.writeRootRefPath(t);
                this.Yt.write(zu);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Yt.write(Uu);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Vn.ye = this.Vn.re.length;
        this.Vn.we = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Yt.write(Qu);
            this.Yt.write(14 + Qu);
            this.outputForwardRefsArray(n);
        }
        this.Yt.write(Bu);
        this.Vn.me = this.Vn.re.length + (this.Vn.we ? 1 : 0);
        this.Vn.Zn = e;
    }
}

class tc {
    ae;
    de;
    he;
    ht;
    _t;
    constructor(t, n, e, s, o) {
        this.ae = t;
        this.de = n;
        this.he = e;
        this.ht = s;
        this._t = o;
    }
}

const nc = (t, n) => {
    const e = t.length;
    for (let s = 1; s < e; s++) {
        const e = t[s];
        if (ec(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === jr || t === Fr && (xs(s) || rc(e, s))) {
                    continue;
                }
                n.Rt(s);
            }
        }
    }
};

const ec = t => typeof t === "object" && t !== null && !xs(t);

const rc = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, or)) {
        return !1;
    }
    const s = n[Qi];
    return xs(s.varProps) && !ic(n) && !sc(t[_r]);
};

const ic = t => !!t[Hi].ht?.size;

const sc = t => t instanceof Map && t.has(":");

function Dn(t, n) {
    n.Pt && n.Pt[0] === "{" && (n.Pt = `(${n.Pt})`);
    const e = t.St(n.Pt, n.ct.length, n.ut);
    return [ e, n.ct ];
}

class oc {
    pe;
    constructor(t) {
        this.pe = t;
    }
}

const lc = t => new oc(t);

let uc = () => !1;

class cc {
    ie;
    constructor(t) {
        this.ie = t;
    }
}

class fc {
    NodeConstructor;
    DomRefConstructor;
    kt;
    fe;
    yt;
    Yt;
    ve=new Map;
    be=new Map;
    _e=0;
    ge=[];
    re=[];
    Ee=[];
    Se;
    $e=0;
    me=0;
    Zn=0;
    ye=0;
    we=!1;
    ke=new Set;
    Ft=new Set;
    Lt=new Set;
    se=new Set;
    Re;
    le=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.kt = e;
        this.fe = s;
        this.yt = o;
        this.Yt = r;
        this.Re = new Ku(this);
    }
    async Jt() {
        await this.Re.serialize();
    }
    async Pe(t, n, e, s) {
        await this.Re.serializePatch(t, n, e, s);
    }
    Kn(t) {
        this.Yt = t;
        this.Re.Kn(t);
    }
    getSeenRef(t) {
        return this.ve.get(t);
    }
    ne(t, n, e) {
        const s = {
            Xt: e,
            Hn: n
        };
        this.ve.set(t, s);
        return s;
    }
    Te(t) {
        const n = [];
        for (;t.Hn; ) {
            n.unshift(t.Xt);
            t = t.Hn;
        }
        n.unshift(t.Xt);
        return n;
    }
    ee(t, n, e) {
        const s = this.Te(t);
        const o = e === void 0;
        e === void 0 && (e = this.re.length);
        this.re[e] = new cc(s);
        o && (this.Ee[e] = n);
        t.Hn = null;
        t.Xt = e;
        o && this.Se?.(e, this.re[e], n);
    }
    Rt(t, n = !1) {
        let e = this.ve.get(t);
        let s;
        if (e) {
            e.Hn && this.ee(e, t);
            s = e.Xt;
        } else {
            s = this.re.length;
            e = {
                Xt: s
            };
            this.ve.set(t, e);
            this.re.push(t);
            this.Ee.push(t);
            this.Se?.(s, t, t);
        }
        return n ? e : s;
    }
    te(t) {
        const n = this.re.length;
        const e = {
            Xt: n
        };
        this.ve.set(t, e);
        this.re.push(t);
        this.Ee.push(t);
        this.Se?.(n, t, t);
        return e;
    }
    Ae(t, n) {
        const e = this.re.length;
        const s = {
            Xt: e
        };
        this.ve.set(n, s);
        this.re.push(t);
        this.Ee.push(n);
        return e;
    }
    ce(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    oe(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    qe(t) {
        const n = this.ve.get(t);
        return n && (n.Hn ? void 0 : n.Xt);
    }
    St(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.be.get(t);
        if (o === void 0) {
            o = this._e + this.ge.length;
            this.be.set(t, o);
            if (s) {
                this.ge.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.ge.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Ie(t, n) {
        this._e = t;
        if (n) {
            this.be.clear();
            for (let t = 0; t < n.length; t++) {
                this.be.set(n[t], t);
            }
        }
    }
}

const kd = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(Vu(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    uc = n ? t => t instanceof n : () => !1;
    return new fc(t, n, e, s, o, r);
};

const ac = (t, n) => t[n];

const hc = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        Xu(t) && (t = Ou(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!hc(Gf(ac, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!hc(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (gu(t)) {
            return !0;
        }
        if (os(t)) {
            return !0;
        }
        if (fi(t)) {
            return !0;
        }
        if (js(t)) {
            return !0;
        }
        if (qu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Ns) {
            return !0;
        }
        if (uc?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (sr(t) || xa(t) || t === io || t === eo) {
            return !0;
        }
    } else if (t === Yi || t === ls || t === as) {
        return !0;
    }
    return !1;
};

const dc = (t, n) => {
    let e = ul(t) ? kn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Ze(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let pc = !1;

const $c = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (pc = !0);
            const n = `{${Ze(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${dc(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = wc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${$c(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${yc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = pc ? "" : `(${JSON.stringify(t).length} chars)`;
        pc = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const yc = t => Gu[t] || `Unknown(${t})`;

const wc = t => Yu[t] || `Unknown(${t})`;

function Wn(t, n, e, s = 0) {
    const o = Vn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Vn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const r = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let i = e; i < t.length; i += 2) {
        s(t[i], t[i + 1]) ? r(i) : o(t[i]) && (n.Tt = t[i + 1]);
        yield;
    }
}

const mc = new WeakMap;

const vc = /^[A-Za-z0-9+/]*$/;

const bc = t => {
    const n = t.Ht === void 0;
    t.Ht ??= new Map;
    return n;
};

const _c = (t, n) => {
    if (n) {
        t.Ht.clear();
        t.Ht = void 0;
    }
};

const gc = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t.k(e);

      case 2:
        const s = t.Zt(e);
        return s === -1 || s === void 0 ? Yi : t.k(s);

      case 14:
        return e;

      case 3:
        return Ju[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t.k(i);
                const f = t.k(l);
                n = Fn(u, f, r !== -1 ? s : null, t);
            } else {
                n = Fn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new _u(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return Ma(null);

      case 30:
        return new ds(t, 0);

      case 31:
        return new Ms(t, null, null, null);

      case 32:
        return new $s(t, null);

      case 33:
        return new ms(t, null, void 0, {});

      case 34:
        return new ws(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = gc(t, s, o);
            const i = Du(r, 0, t);
            tf(s) && t.Ht.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Cs(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        mc.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        {
            if (!(t => {
                if (typeof t !== "string" || !vc.test(t)) {
                    return !1;
                }
                const n = t.length % 4;
                if (n === 0) {
                    return !0;
                }
                if (n === 1) {
                    return !1;
                }
                const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(t[t.length - 1]);
                return (e & (n === 2 ? 15 : 3)) === 0;
            })(e)) {
                throw er(38);
            }
            const t = e.length;
            const n = Math.floor(t / 4);
            const s = t % 4;
            const o = n * 3 + (s ? s - 1 : 0);
            return new Uint8Array(o);
        }

      case 38:
        return y(null);

      case 10:
        return zn(t, e);

      case 11:
        const l = zn(t, e);
        if (ul(l)) {
            Bl(l);
            return hu(l);
        }
        throw er(17, [ typeof l ]);

      case 39:
        return new Ns({});

      case 42:
        return new Ns({
            j: null,
            rt: !0
        });

      case 43:
        return new Ns({
            j: null,
            rt: !1
        });

      case 40:
      case 44:
        return new us(null, null, null, null);

      case 41:
        return new Zu;

      default:
        throw er(18, [ n ]);
    }
};

function zn(t, n) {
    return n ? t.rootVNode ? Sl(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Ec = (t, n, e) => {
    let s = null;
    let o = null;
    if (nr(t)) {
        o = t;
    } else {
        if (!tr(t)) {
            throw er(7, [ t ]);
        }
        s = t;
    }
    return ba(s, n, null, o, e);
};

const Sc = (t, n, e) => ba(null, n, t, null, e);

const kc = (t, n) => ba(null, t, null, null, n);

const Rc = (t, n, e) => {
    const s = kc(t, e);
    return s;
};

const Pc = (t, n, e, s) => ba(t, e, null, n, s);

const Tc = (t, n, e, s, o) => {
    const r = Pc(t, n, e, o);
    r.Me(s);
    return r;
};

const Ac = (t, n, e, s) => {
    const o = Ec(t, n, s);
    return o;
};

const qc = (t, n, e, s) => {
    const o = Sc(t, n, s);
    return o;
};

const Ic = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

function Un(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Mc = (t, n, e) => new Ms(null, t, n, e || null);

class Nc {
    Ne;
    yt;
    $n=null;
    Mt=!1;
    fn;
    k;
    pn;
    xe=0;
    Kt=null;
    Ce=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.pn = t;
        this.fn = n;
        this.Ne = rr;
        this.yt = new WeakMap;
        this.k = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return ta(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        if (Ve) {
            return kd(t, n, e, this.setHostProp.bind(this), this.yt, s);
        }
        throw Error("Serialization context is only available on the server");
    }
    $t() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const xc = Symbol();

const Rd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[xc] = t;
    return n;
};

class Cc {}

class Oc {}

const jc = t => {
    const n = t.At;
    return !!n && (n.vnodeData[0] & 32) !== 0;
};

const Lc = t => {
    t.catch(() => {});
};

function Bn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Qn(n, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    const i = t => {
        Lc(t);
        o.push(t);
        o.push(Promise);
    };
    await (async () => {
        for (;o.length; ) {
            let e = "render";
            try {
                const c = o.pop();
                if (c === Cc) {
                    const s = o.pop();
                    if (__EXPERIMENTAL__.errorBoundary && jc(n)) {
                        continue;
                    }
                    e = "hook";
                    await t(() => o.push(s()));
                    continue;
                }
                if (__EXPERIMENTAL__.errorBoundary && c === Oc) {
                    const t = o.pop();
                    if (jc(n)) {
                        continue;
                    }
                    const e = t.apply(n);
                    fi(e) && await e;
                    continue;
                }
                if (typeof c === "function") {
                    if (c === Promise) {
                        const t = o.pop();
                        if (__EXPERIMENTAL__.errorBoundary && jc(n)) {
                            continue;
                        }
                        o.push(await t);
                    } else {
                        const t = c.apply(n);
                        fi(t) && await t;
                    }
                    continue;
                }
                if (__EXPERIMENTAL__.errorBoundary && jc(n)) {
                    fi(c) && c.catch(() => {});
                    continue;
                }
                Jn(n, r, i, c, s);
            } catch (t) {
                n.handleError(t, n.getOrCreateLastNode(), e);
            } finally {
                const t = n.streamHandler.waitForPendingFlush();
                fi(t) && await t;
            }
        }
    })();
}

function Hn(t, n) {
    t(n);
    __EXPERIMENTAL__.errorBoundary && typeof n === "function" && t(Oc);
}

function Jn(t, n, e, s, o) {
    if (s == null) {
        t.textNode("");
    } else if (typeof s === "boolean") {
        t.textNode("");
    } else if (typeof s === "number") {
        t.textNode(s + "");
    } else if (typeof s === "string") {
        t.textNode(s);
    } else if (typeof s === "object") {
        if (Array.isArray(s)) {
            for (let t = s.length - 1; t >= 0; t--) {
                Hn(n, s[t]);
            }
        } else if (Su(s)) {
            t.openFragment(Zi);
            const e = t.getOrCreateLastNode();
            const o = s instanceof Ms ? s.st() : s;
            n(t.closeFragment);
            n(() => ta(o, e, ".", t));
            n(Cc);
        } else if (fi(s)) {
            t.openFragment(Zi);
            n(t.closeFragment);
            e(s);
            n(() => t.streamHandler.flush());
        } else if (function r(t) {
            return !!t[Symbol.asyncIterator];
        }(s)) {
            n(async () => {
                if (__EXPERIMENTAL__.errorBoundary && jc(t)) {
                    return;
                }
                const n = () => ({
                    currentStyleScoped: o.currentStyleScoped,
                    parentComponentFrame: o.parentComponentFrame
                });
                try {
                    for await (const e of s) {
                        await Qn(t, e, n());
                        await t.streamHandler.flush();
                    }
                } catch (e) {
                    t.handleError(e, t.getOrCreateLastNode(), "render");
                    await Qn(t, null, n());
                }
            });
        } else {
            const r = s;
            const i = r.type;
            if (typeof i === "string") {
                (function e(t, n) {
                    const e = es(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(r, o.currentStyleScoped);
                let s = null;
                const c = t.openElement(i, r.key, r.varProps, r.constProps, o.currentStyleScoped, s, !!(r.flags & 4));
                c && t.htmlNode(c);
                __EXPERIMENTAL__.errorBoundary && es(r, $r) && n(((t, n) => {
                    const e = t.At;
                    t.At = n;
                    return () => {
                        t.At = e;
                    };
                })(t, t.getOrCreateLastNode()));
                n(t.closeElement);
                if (i === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (i === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.qt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = r.children;
                l != null && Hn(n, l);
            } else if (nr(i)) {
                if ((__EXPERIMENTAL__.suspense || __EXPERIMENTAL__.errorBoundary) && (t => typeof t === "function" && xc in t)(i)) {
                    n(() => (t => t[xc])(i)(t, r, o, n));
                    return;
                }
                if (i === eo) {
                    const e = r.key != null ? {
                        [Lr]: r.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = r.children;
                    s != null && Hn(n, s);
                } else if (i === io) {
                    const e = o.parentComponentFrame;
                    if (e) {
                        const s = e.componentNode.id || "";
                        const i = {};
                        i[ar] = s;
                        t.openProjection(i);
                        const c = e.componentNode;
                        const l = t.getOrCreateLastNode();
                        const u = R(c, r, t);
                        i[fr] = u;
                        n(Bn(o, o.currentStyleScoped, o.parentComponentFrame));
                        n(t.closeProjection);
                        const f = r.children || null;
                        const a = e.consumeChildrenForSlot(l, u) || f;
                        f && a !== f && t.addUnclaimedProjection(e, "", f);
                        Hn(n, a);
                        n(Bn(o, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = Zi;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (i === lo) {
                    t.commentNode(es(r, "data") || "");
                } else if (i === co) {
                    t.streamHandler.flush();
                    const s = r.children;
                    let i;
                    i = nr(s) ? s({
                        async write(n) {
                            await Qn(t, n, {
                                currentStyleScoped: o.currentStyleScoped,
                                parentComponentFrame: o.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : s;
                    fi(i) ? e(i) : n(i);
                } else if (i === oo) {
                    t.htmlNode(es(r, "data"));
                } else if (i === uo) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    Hn(n, r.children);
                } else if (xa(i)) {
                    const e = {};
                    t.openComponent(e);
                    const s = t.getOrCreateLastNode();
                    n(Bn(o, o.currentStyleScoped, o.parentComponentFrame));
                    n(() => t.closeComponent());
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(r.children, o.currentStyleScoped, o.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Na];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(or, o);
                        s.setProp(Fr, r);
                        n.key !== null && s.setProp(Lr, n.key);
                        return Uo(t, s, s, o, r);
                    })(t, r, i);
                    if (fi(l)) {
                        Lc(l);
                        n(async () => {
                            await t.streamHandler.flush();
                            const e = await l;
                            const r = mo(s.getProp(vr));
                            n(e);
                            n(Bn(o, r, c));
                        });
                    } else {
                        n(l);
                        const t = mo(s.getProp(vr));
                        n(Bn(o, t, c));
                    }
                } else {
                    const s = {
                        [Lr]: r.key
                    };
                    t.openFragment(s);
                    n(t.closeFragment);
                    const o = t.getParentComponentFrame();
                    const c = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Uo(t, o, n, e, s.props);
                    })(t, o && o.componentNode, i, r);
                    fi(c) ? e(c) : n(c);
                }
            }
        }
    }
}

function Yn(t, n, e, s) {
    if (!__EXPERIMENTAL__.errorBoundary) {
        throw n;
    }
    for (let o = e; o; o = o.parentComponent) {
        const e = Zn(o);
        if (!e || !e.It) {
            continue;
        }
        if (t.Mt && e.Nt) {
            throw n;
        }
        xf(e, n, s);
        $i(t).xt = !0;
        t.Mt && If(e);
        Gn(t, o, e);
        return;
    }
    throw n;
}

function Gn(t, n, e) {
    const s = new Map;
    let o = null;
    let r = 0;
    for (let t = n; t; t = t.parentComponent) {
        t.id && s.set(t.id, {
            node: t,
            depth: r++
        });
        if (t !== n && !o) {
            const n = Zn(t);
            n?.error === void 0 && k(t.getProp(Fr)) || (o = t);
        }
    }
    const i = {
        node: null,
        depth: -1
    };
    const c = n.children;
    if (c) {
        for (let n = 0; n < c.length; n++) {
            Kn(t, c[n], s, i);
        }
    }
    if (i.node) {
        const s = i.node.parentComponent;
        if (i.node === n) {
            t.Ct(o);
        } else if (s?.id) {
            t.Ct(s);
            e.projectedContentOwner = s;
        }
    }
}

function Zn(t) {
    const n = t.getProp(br);
    return n ? oi(n, _f.id, 0) : null;
}

function Kn(t, n, e, s) {
    n.vnodeData[0] |= 32;
    const o = n.getProp(ar);
    if (o) {
        const t = e.get(o);
        if (t) {
            t.node.removeProp(n.getProp(fr) ?? "");
            if (t.depth > s.depth) {
                s.node = t.node;
                s.depth = t.depth;
            }
        }
    }
    Pn(t, n);
    const r = n.getProp(Xr);
    if (r) {
        for (let n = 0; n < r.length; n++) {
            const e = r[n];
            gu(e) && Pn(t, e);
        }
    }
    const i = n.children;
    if (i) {
        for (let n = 0; n < i.length; n++) {
            Kn(t, i[n], e, s);
        }
    }
}

const Fc = () => pa;

const Xc = async t => {
    const [n, e] = pa;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = xn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Dc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Oo();
    if (e) {
        return e;
    }
    const r = ba(null, "_rsc", Xc, null, [ t, {} ], o.$);
    const i = _s(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Wc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (fi(t)) {
        return t.then(n, s);
    }
    const o = Vc(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return fi(i) ? i.then(n, s) : n(i);
};

const Vc = t => t && t.__brand === "resource";

function te(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        !n.gt.startsWith("_") && (Array.isArray(n.Ot) || s && n.jt) && (n = ba(null, "_run", C, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = Ln(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (sr(o)) {
                i(c(o));
                ne(t, n, o);
            } else if (o != null) {
                const e = te(t, n, o, s);
                e && i(e);
            }
        }
    } else if (sr(r)) {
        o = c(r);
        ne(t, n, r);
    }
    return o;
}

function ne(t, n, e) {
    const s = Ii(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.Lt.add(r);
        t.Ft.add(e);
    }
}

const zc = (t, n, e) => {
    Qc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const Uc = (t, n, e) => {
    Qc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Bc = (t, n, e) => {
    Qc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Qc = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = Hc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + qi(i), e, s);
            }
        } else {
            r(t + qi(n), e, s);
        }
    }
};

const Hc = () => {
    const t = Jf();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Ur);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Ur, s);
    }
    let o = t.$.getHostProp(e, Br);
    o === null && (o = 0);
    t.$.setHostProp(e, Br, o + 1);
    let r = t.$.getHostProp(e, Qr);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, Qr, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const Jc = function(t, n) {
    const e = Ie(n);
    return Vf(e, () => {
        typeof this === "string" && $a(ya(e, this));
        const s = pa?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const r = pa?.[0];
        if (!r || r.flags & 32) {
            return;
        }
        mn(e, r, 4);
        const i = n.ownerDocument;
        i.__hmrDone = i.__hmrT;
    });
};

let Yc;

function ee(t) {
    const n = Qf();
    if (!n) {
        return;
    }
    Yc ||= Sc(Jc, "_hmr");
    const e = n._;
    const s = Yc.w([ e, t ]);
    Uc("qHmr", s);
}

function re(t, n, e, s, o) {
    const r = ll();
    yl(r, fr, o);
    r.parent = n;
    yl(n, o, r);
    yl(r, or, e);
    yl(r, Fr, s);
    r.dirty = 4;
    pn(t, r, 1);
    return r;
}

function ie(t, n) {
    yl(t, ur, n);
    t.flags |= 2048;
}

function se(t, n, e) {
    yl(n, Fr, e);
    mn(t, n, 4);
}

function oe(t, n, e, s) {
    yl(n, s, null);
    const o = [];
    kt(t, o, e);
    ql(o);
    if (e.flags & 2048) {
        const t = $l(e, ur, null);
        t && t.replaceChildren();
        yl(e, ur, null);
        e.flags &= -2049;
    }
}

let Gc = Promise.resolve();

const Zc = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Kc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !Zc.has(t));
};

function* le(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ce(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* ue(t, n, e = Array(n.length / 2)) {
    const s = bc(t);
    const o = n.length / 2;
    const r = new Uint8Array(o);
    const i = t.k;
    const c = s => {
        if (!r[s]) {
            r[s] = 1;
            const o = s * 2;
            const i = n[o];
            const c = n[o + 1];
            e[s] = i === 0 ? c : gc(t, i, c);
        }
        return e[s];
    };
    t.k = t => c(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < o; t++) {
            c(t);
            yield;
        }
        for (let s = 0; s < o; s++) {
            const o = s * 2;
            const r = n[o];
            const i = n[o + 1];
            const c = e[s];
            n[o] = 0;
            n[o + 1] = c;
            tf(r) && (yield* fe(t, c, r, i));
            yield;
        }
    } finally {
        t.k = i;
        _c(t, s);
    }
    return e;
}

function* ce(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = gc(t, n, e);
    tf(n) && (yield* fe(t, s, n, e));
    return s;
}

function* fe(t, n, e, s) {
    if (e === 0) {
        return;
    }
    if (e === 5 && s !== 0 && !Array.isArray(s)) {
        throw Error("Invalid Object payload");
    }
    e !== 4 && Array.isArray(s) && (s = yield* le(t, s));
    switch (e) {
      case 4:
        yield* le(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Kc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = mc.get(t);
            if (e) {
                if (mc.has(o)) {
                    throw er(37);
                }
                r(o);
            } else {
                i(o);
            }
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                const s = t[e];
                const o = t[e + 1];
                Kc(s, o) && (n[s] = o);
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t._t = e[0];
            t.h = e[1];
            t.Xt = e[2];
            t.dt = e[3];
            break;
        }

      case 29:
        n[Na][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Dt = e[0];
            t.ht = new Set(e.slice(1));
            he(t.ht, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ut = t.getSyncFn(o[0]);
            e.ct = o[1];
            e.Dt = ls;
            e.h = o[2];
            e.h |= 1;
            e._ = o[3];
            e.ht = new Set(o.slice(4));
            (function r(t) {
                if (t._ !== null && ul(t._)) {
                    const n = t._;
                    const e = t.ht;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (tr(e)) {
                                const o = $l(n, e, null);
                                if (o !== null) {
                                    t.Dt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Ul(n);
                        e && n.firstChild === n.lastChild && hl(e) && (t.Dt = Vl(e));
                    }
                }
            })(e);
            he(e.ht, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Wt = e[0];
            e[1] && (t.ht = new Set(e[1]));
            e[2] && (t.wt = new Set(e[2]));
            e[3] && (t.vt = new Set(e[3]));
            e[4] && (t.Vt = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.zt = !0);
            const o = e.length > 6;
            o && (t.Dt = e[6]);
            t.Dt === ls && (t.h |= 1);
            if (e[7] !== void 0 && e[7] !== 1) {
                t.Ut = e[7] ?? 1;
                t.Bt = [];
            }
            t.Qt = e[8] ?? 0;
            he(t.ht, t);
            he(t.wt, t);
            he(t.vt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Wt = r[0];
            const i = o.Wt.resolve(t).catch(() => {});
            Gc = Gc.finally(() => i);
            r[1] && (o.ht = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Dt = r[2]);
            e !== 34 && o.Dt !== ls && (o.h &= -2);
            he(o.ht, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === Yi) {
                o = new Cs(eo, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[Qi] = o;
            const r = t[Hi];
            r.ht = e[3];
            de(r.ht, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.j = s[0];
            t.data.rt = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            ae(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            ae(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = Fu(n);
            const o = t.Ht.get(e);
            if (o) {
                t.Ht.delete(e);
                yield* fe(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Cu(n);
            c.h = r;
            c.ht = i;
            de(c.ht, e);
            break;
        }

      default:
        throw er(16, [ e ]);
    }
}

function ae(t) {
    const n = Ve;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[yi] ||= new Map;
    e[yi].set(t.property, t);
}

function he(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function de(t, n) {
    if (t) {
        for (const [, e] of t) {
            he(e, n);
        }
    }
}

const tf = t => t >= 23 || t === 4 || t === 5;

const nf = new WeakMap;

const ef = Symbol();

const rf = (t, n) => {
    if (!Array.isArray(n) || ul(n) || (t => Ze(t) && ef in t)(n)) {
        return n;
    }
    let e = nf.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new sf(t, n));
        nf.set(n, e);
    }
    return e;
};

class sf {
    $;
    Oe;
    constructor(t, n) {
        this.$ = t;
        this.Oe = n;
    }
    get(t, n, e) {
        if (n === ef) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.Oe.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.Oe[o];
        const i = this.Oe[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = bc(c);
        try {
            const e = gc(c, r, i);
            Reflect.set(t, n, e);
            this.Oe[o] = 0;
            this.Oe[o + 1] = e;
            tf(r) && ((t, n, e, s) => {
                const o = bc(t);
                try {
                    const o = fe(t, n, e, s);
                    for (;!o.next().done; ) {}
                } finally {
                    _c(t, o);
                }
            })(c, e, r, i);
            return e;
        } finally {
            _c(c, l);
        }
    }
    has(t, n) {
        if (n === ef) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === ef) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.Oe.length / 2) {
            return o;
        }
        const i = r * 2;
        this.Oe[i] = 0;
        this.Oe[i + 1] = e;
        return !0;
    }
}

const of = t => {
    if (!t.je) {
        t.je = !0;
        t.Le();
    }
};

const lf = (t, n, e) => {
    const s = {
        Fe: t,
        Le: void 0,
        je: !1
    };
    const o = Yo(() => {
        ((t, n, e) => {
            t.je = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.Fe.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        of(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.jn?.();
            n(t);
        }, t => {
            o.jn?.();
            e(t);
        });
    });
    s.Le = o;
    return s;
};

async function pe(t) {
    const n = kd(null, null, () => "", () => {}, new WeakMap);
    n.Rt(t);
    await n.Jt();
    return n.Yt.toString();
}

async function $e(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = me(n, () => e);
    s.Gt = e;
    await uf(ue(s, n, e));
    return e[0];
}

const uf = t => new Promise((n, e) => {
    const s = lf(t, n, e);
    of(s);
});

function ye(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function we(t) {
    let n;
    const e = me(t, () => n);
    n = rf(e, t);
    e.Gt = n;
    return e;
}

function me(t, n) {
    const e = {
        k: t => ye(t, n()),
        Zt: t => e.Tt?.[+t],
        getSyncFn: () => () => {},
        yt: new WeakMap,
        element: null,
        Tt: null
    };
    Wn(t, e);
    return e;
}

const cf = (t, n) => {
    const e = new WeakSet;
    return Gf(ff, t, e, "_", n);
};

const ff = (t, n, e, s) => {
    const o = Fu(t);
    if (o == null) {
        return t;
    }
    if (hf(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Su(o)) {
            return t;
        }
        if (hc(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (fi(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Ke(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw er(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw er(3, [ o ]);
                    }
                    ff(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Mi) {
                return t;
            }
            if (Ge(o)) {
                for (const [t, s] of Object.entries(o)) {
                    ff(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw er(3, [ i ]);
    }
    return t;
};

const af = /*#__PURE__*/ new WeakSet;

const hf = t => {
    if (Ze(t) || nr(t)) {
        return !af.has(t) && !($f in t);
    }
    return !0;
};

const df = t => !!t && (Ze(t) || typeof t === "function") && (af.has(t) || $f in t);

const pf = t => {
    (Ze(t) && t !== null || typeof t === "function") && af.add(t);
    return t;
};

const $f = Symbol();

const yf = Symbol();

const wf = t => /*#__PURE__*/ Object.freeze({
    id: qi(t)
});

const mf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Oo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o._, t, n);
    s(1);
};

const vf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Oo();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o._, t);
    if (typeof n === "function") {
        return s(je(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw er(8, [ t.id ]);
};

const bf = t => {
    const n = Hf();
    const e = n._;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const _f = /*#__PURE__*/ wf("qk-error");

const gf = (t, n) => {
    try {
        return t();
    } catch {
        return n;
    }
};

const Ef = "An error occurred";

const Sf = t => bo(gf(() => t instanceof Error ? `${t.name}: ${t.message}\n${t.stack ?? ""}` : t + "", "unknown"));

const kf = /*#__PURE__*/ Symbol();

const Rf = t => {
    const n = Error(Ef);
    n.digest = Sf(t);
    Object.defineProperty(n, kf, {
        value: !0
    });
    return n;
};

const Pf = t => {
    if (t instanceof Error) {
        return t;
    }
    let n;
    try {
        n = t + "";
    } catch {
        try {
            n = Object.prototype.toString.call(t);
        } catch {
            n = Ef;
        }
    }
    const e = Error(n);
    e.cause = t;
    return e;
};

const Tf = (t, n, e) => {
    try {
        if (e) {
            const s = e(t);
            if (s instanceof Error) {
                return (t => gf(() => {
                    t.message;
                    t.name;
                    for (const n in t) {
                        t[n];
                    }
                    return !0;
                }, !1))(s) ? s : Rf(t);
            }
            if (s != null) {
                n && fi(s);
                return Rf(t);
            }
        }
        if (gf(() => t instanceof Error && kf in t, !1)) {
            return t;
        }
        if (!n) {
            return Rf(t);
        }
        if (t instanceof Error) {
            return t;
        }
        const s = t?.message;
        if (typeof s === "string") {
            const n = Error(s);
            n.cause = t;
            return n;
        }
        return Pf(t);
    } catch {
        return Rf(t);
    }
};

const Af = (t, n, e, s) => {
    if (!t) {
        return;
    }
    try {
        const o = Sf(n);
        Promise.resolve(t(Pf(n), {
            phase: e,
            boundaryId: s,
            digest: o
        })).catch(He);
    } catch (t) {
        He(t);
    }
};

const qf = /*#__PURE__*/ new WeakSet;

const If = t => {
    qf.add(t);
};

const Mf = /*#__PURE__*/ Symbol();

const Nf = (t, n) => {
    try {
        Object.defineProperty(t, Mf, {
            value: n,
            configurable: !0
        });
    } catch {}
};

const xf = (t, n, e = "render") => {
    t.error = n ?? Pf(n);
    const s = t.Xe;
    s && Af(s, n, (t => gf(() => t?.[Mf], void 0))(n) ?? e, t.boundaryId ?? "");
};

const Cf = t => {
    const n = t.detail;
    if (n?.importError) {
        return;
    }
    const e = n.element;
    if (!e || e.ownerDocument !== t.currentTarget) {
        return;
    }
    const s = e.closest(Ir)?.qContainer;
    const o = s?.vNodeLocate(e);
    if (!s || !o) {
        return;
    }
    try {
        s.handleError(n.error, o, "event");
    } catch (t) {
        He(t);
    }
};

function ve(t, n) {
    const e = t.getHostProp(n, br);
    return e ? oi(e, _f.id, 0) : null;
}

const Pd = (t, n = t => t.boundary.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Td = new WeakMap;

class qd {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Id(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return Pd(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Id = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const Ad = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = Qf()?.$;
    return t?.outOfOrderStreaming === !0 && !Ed(t);
};

const Of = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && Au(t, n, r);
};

const jf = new WeakMap;

function* be(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.Kt}"]${dr}`);
    const o = Lf(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(pr) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        yield* _e(t, e, i.textContent);
        yield;
    }
}

const Lf = t => {
    let n = jf.get(t);
    if (!n) {
        n = new WeakSet;
        jf.set(t, n);
    }
    return n;
};

function* _e(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, r, i] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.tn.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.tn[e * 2 + t] = s[t];
            yield;
        }
        yield* Vn(n.tn, t, e * 2);
        n.nn = rf(t, n.tn);
        n.nn.length = n.tn.length / 2;
        n.en = n.Tt;
    }(t, n, s, o);
    Ff(n, r || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.suspense || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t.k(s.rootId);
            const r = s.subscriptions;
            if (o instanceof ds) {
                r instanceof Set && Of(t, o, o, o.ht ||= new Set, r);
            } else {
                if (!(r instanceof Map)) {
                    continue;
                }
                const n = Cu(o);
                const e = Ou(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ht ||= new Map;
                for (const [o, i] of r) {
                    let r = s.get(o);
                    if (!r) {
                        r = new Set;
                        s.set(o, r);
                    }
                    Of(t, n, e, r, i);
                }
            }
        }
    })(t, i === void 0 ? void 0 : n.k(i));
}

const Ff = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.en ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Tt = e;
};

const Xf = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function ge(t, n) {
    const e = t.qVNodeDataState ||= {
        rn: [],
        sn: null
    };
    t.qProcessVNodeDataPatch ||= n => ge(t, ke(t, n));
    t.qVNodeDataReady = !1;
    e.rn.push(n);
    Ee(t, e);
}

function Ee(t, n) {
    if (n.sn) {
        return;
    }
    const e = n.rn.shift();
    if (!e) {
        Se(t);
        return;
    }
    n.sn = lf(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.sn = null;
            Ee(t, n);
        }
    }, e => {
        n.sn = null;
        He(e);
        Se(t);
    });
    of(n.sn);
}

function Se(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* ke(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* Re(t, s || void 0, e, o, n.textContent));
}

function* Re(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const w = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const m = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* m(s));
            yield;
        }
    };
    const b = t => {
        const n = w.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const _ = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const v = function*(n, e, s, o, r, i, c, l) {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let w = 0;
        let m = 0;
        let g = -1;
        let S = null;
        const k = () => {
            let t = 0;
            for (;Df(m = r.charCodeAt(y)); ) {
                t += 1 << m - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            S = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(S = _(e)); ) {
                    e = e.parentNode;
                }
                yield* v(n, t, s, S, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                S = s;
                let t;
                do {
                    S = n.nextNode();
                    if (!S) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(S);
                } while (t !== 32 && t !== 65);
                S = null;
            } else if (R === 9) {
                S = s;
                do {
                    S = _(S);
                    if (!S) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(S) !== 8);
                yield* v(n, s, s, S, "", null, c);
            } else if (R === 6) {
                S = _(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* v(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = w;
                    if (y < f) {
                        p += k();
                        if (m === 126) {
                            g = p;
                            y++;
                            m = y < f ? r.charCodeAt(w) : 33;
                        }
                        w = Wf(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || i.set(u ? Ei(l, h) : h, s);
                    const t = r.substring(y, w);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== gi || n.charCodeAt(1) !== gi || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    yield* E(c, s, t);
                    S = _(s);
                    S && (n.currentNode = S);
                }
            }
            yield;
        } while (s = S || n.nextNode());
    };
    const g = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        yield* v(r, e, e, _(e), s, n.qVNodeRefs, n, o);
    };
    const E = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* g(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.suspense && n !== void 0 ? yield* E(e, s, n, o) : yield* g(e, s, o);
        return;
    }
    yield* m(t);
    const S = t.createTreeWalker(t, 129);
    yield* v(S, null, S.firstChild(), null, "", null, null);
}

const Df = t => 33 <= t && t <= 46;

const Wf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Df(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Pe(t) {
    return t.ln === 3;
}

function Te(t, n) {
    const e = t.un ||= {
        rn: [],
        sn: null
    };
    t.ln = 2;
    e.rn.push(n);
    Ae(t, e);
}

const Vf = (t, n) => {
    const e = t;
    if (Pe(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!Pe(e)) {
                    (e.cn ||= []).push(s);
                    return;
                }
                Xf(e.document, () => {
                    Pe(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function Ae(t, n) {
    if (n.sn) {
        return;
    }
    const e = n.rn.shift();
    if (!e) {
        qe(t);
        return;
    }
    n.sn = lf(e, () => {
        n.sn = null;
        Ae(t, n);
    }, e => {
        n.sn = null;
        He(e);
        qe(t);
    });
    of(n.sn);
}

function qe(t) {
    const n = t.ln;
    if (n !== 2) {
        return;
    }
    t.ln = 3;
    t.un = void 0;
    const e = t.cn;
    t.cn = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function Ie(t) {
    const n = Ne(t);
    if (!n) {
        throw er(24);
    }
    return Me(n);
}

function Me(t) {
    const n = t;
    return n.qContainer ||= new zf(n);
}

function Ne(t) {
    return t.closest(Ir);
}

function xe(t, n) {
    const e = t + "";
    const s = n?.closest(Ir);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.suspense || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const r = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            ge(t, function* i(t, n, e, s, o, r) {
                yield* Re(t, n, e, s, o);
                for (let n = 0; n < r.length; n++) {
                    yield* ke(t, r[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, r));
        })(t, e, n);
        Xf(t, () => {
            o.element.qContainer === o && Te(o, be(o, e));
        });
    }
}

class zf extends Nc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    yt=new WeakMap;
    De;
    Kt;
    Tt=null;
    vNodeLocate=t => Sl(this.rootVNode, t);
    ln=0;
    cn=void 0;
    un=void 0;
    tn;
    nn;
    en=null;
    We=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Tr);
        if (!this.qContainer) {
            throw er(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.Ce = t.getAttribute(Er);
        this.Kt = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = sl(this.element);
        this.tn = [];
        this.nn = [];
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= xe);
        this.De = gr(n, this.Kt) || Gi;
        this.Ve();
        t.qContainer = this;
        t.qDestroy = () => this.jn();
        __EXPERIMENTAL__.errorBoundary && function e(t) {
            if (!t.qErrorHandler) {
                t.qErrorHandler = Cf;
                t.addEventListener?.("qerror", Cf);
            }
        }(this.document);
        this.ln = 1;
        (function s(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            ge(e, function* s(t) {
                yield* Re(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        Xf(n, () => {
            this.ln === 1 && Te(this, this.ze());
        });
    }
    * ze() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.Kt}"]:not(${dr})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${dr})`);
        if (n) {
            this.tn = JSON.parse(n.textContent);
            yield* Vn(this.tn, this);
            this.en = this.Tt;
            const e = this.tn.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.nn = s !== null && e > 0 && e >= +s ? yield* ue(this, this.tn) : rf(this, this.tn);
        }
        __EXPERIMENTAL__.suspense && (yield* be(this));
        this.Ue();
        t.setAttribute(Tr, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    jn() {
        this.vNodeLocate = () => null;
        this.tn.length = 0;
        this.nn.length = 0;
        this.k = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(Tr);
        const n = t.ownerDocument;
        this.un = void 0;
        this.ln = 0;
        const e = n.querySelector(Ir) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    Ue() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(mr);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Xn(t, n) {
        this.nn[t] = n;
    }
    parseQRL(t) {
        return Xn(t, this);
    }
    handleError(t, n, e = "render") {
        if (!__EXPERIMENTAL__.errorBoundary) {
            const e = n && this.resolveContext(n, _f);
            if (!e) {
                Je(t);
                return;
            }
            e.error = t;
            return;
        }
        const s = t ?? Pf(t);
        let o = n;
        for (;o; ) {
            const n = this.resolveContextHost(o, _f);
            if (!n) {
                break;
            }
            const r = ve(this, n);
            if (r && r.error === void 0) {
                r.error = s;
                const o = this.getHostProp(n, Fr);
                Af(o?.onError$, t, e, r.boundaryId ?? "");
                mn(this, n, 4);
                return;
            }
            if (n.dirty & 4) {
                He(t);
                return;
            }
            o = this.getParentHost(n);
        }
        Je(t);
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, br);
        s == null && this.setHostProp(t, br, s = []);
        si(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        const e = this.resolveContextHost(t, n);
        return e ? oi(this.getHostProp(e, br), n.id, 0) : void 0;
    }
    resolveContextHost(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, br);
            if (e != null && li(e, n.id, 0)) {
                return t;
            }
            t = this.getParentHost(t);
        }
        return null;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (dl(n)) {
                if ($l(n, or, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        yl(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Xr:
          case Fr:
          case or:
          case br:
          case _r:
            s = this.k;
            break;

          case Dr:
          case Br:
            s = parseInt;
            break;
        }
        return $l(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    k=t => ye(t, this.nn);
    Zt(t) {
        return this.en?.[t];
    }
    getSyncFn(t) {
        const n = this.De[t];
        return n;
    }
    Be(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, vr);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, vr, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.We == null) {
            this.We = new Set;
            const t = this.document.querySelectorAll(wr);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.We.add(e.getAttribute(yr));
            }
        }
        if (!this.We.has(n)) {
            this.We.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(yr, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Ve() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === Yr) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.pn = {
            containerAttributes: t
        };
    }
}

let Uf;

let Md;

if (Ve) {
    const t = Be();
    t && (Md = new t);
}

function Ce(t) {
    if (Md) {
        const t = Md.getStore();
        if (t) {
            return t;
        }
    }
    if (Uf === void 0) {
        const n = Qf();
        if (n && n.fn) {
            return n.fn;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Uf;
}

function Oe(t, n) {
    if (Md) {
        return Md.run(t, n);
    }
    const e = Uf;
    const s = () => {
        Uf = e;
    };
    Uf = t;
    return ai(n, t => {
        s();
        return t;
    }, t => {
        s();
        throw t;
    });
}

let Bf;

const Qf = () => Bf;

const Hf = () => {
    const t = Qf();
    if (!t) {
        throw er(9);
    }
    return t;
};

const Jf = () => {
    const t = Qf();
    if (!t || t.an !== Cr) {
        throw er(10);
    }
    return t;
};

function je(t, n, ...e) {
    return Le.call(this, t, n, e);
}

function Le(t, n, e) {
    const s = Bf;
    try {
        Bf = t;
        return n.apply(this, e);
    } finally {
        Bf = s;
    }
}

const Yf = (t, n, e = Ie(n)) => {
    const s = Sl(e.rootVNode, n);
    const o = e.fn;
    o && function r(t) {
        if (Md) {
            Md.enterWith(t);
            return;
        }
        Uf = t;
    }(o);
    const i = Xe(o, s, t);
    i.$ = e;
    return i;
};

function Fe(t, n, e) {
    const s = {
        _: n,
        an: Cr,
        hn: void 0,
        fn: t,
        $: e,
        dn: void 0
    };
    return s;
}

function Xe(t, n, e) {
    const s = {
        _: n,
        an: e,
        hn: void 0,
        fn: t,
        $: void 0
    };
    return s;
}

const Gf = (t, ...n) => {
    if (typeof t === "function") {
        if (!Bf) {
            return t(...n);
        }
        {
            const e = Bf.hn;
            try {
                Bf.hn = void 0;
                return t(...n);
            } finally {
                Bf.hn = e;
            }
        }
    }
    if (Su(t)) {
        return t.untrackedValue;
    }
    return Fu(t);
};

const Zf = /*#__PURE__*/ Fe(void 0, void 0, void 0);

const Kf = (t, n, e, s, o) => {
    const r = Zf.hn;
    const i = Zf.$;
    try {
        Zf.hn = w(n, e, o);
        Zf.$ = s;
        return Le(Zf, t);
    } finally {
        Zf.hn = r;
        Zf.$ = i;
    }
};

const ta = (t, n, e, s, o) => {
    t instanceof Ms && t._ !== n && n && (t._ = n);
    return Kf(() => t.value, n, e, s, o);
};

const na = () => Qf()?._;

const ea = () => {
    const t = Qf();
    if (t) {
        return t.an;
    }
};

const ra = () => {
    const t = Qf();
    if (t) {
        return t.$;
    }
};

const ia = t => t;

const sa = t => t.l || Promise.resolve();

let oa;

class la {
    Et;
    gt;
    Qe;
    He;
    $;
    constructor(t, n, e, s, o) {
        this.Et = t;
        this.gt = n;
        this.Qe = e;
        this.He = s;
        s && this.Je(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        ze && t && We(t, .8);
    }
    get ot() {
        return bd(this.gt);
    }
    Je(t) {
        this.He = t;
        fi(t) && t.then(t => this.He = t, t => {
            const n = `qrl ${this.gt} failed to load`;
            if (Ve) {
                console.error(n, t);
            } else if (ze) {
                const e = this.Et === null ? "symbol:" + this.gt : "chunk:" + this.Et;
                const s = this.$;
                let o = s && oa?.get(s);
                if (!o?.has(e)) {
                    if (s) {
                        if (!o) {
                            o = new Set;
                            (oa ||= new WeakMap).set(s, o);
                        }
                        o.add(e);
                    }
                    console.error(n, t);
                }
            }
            this.He = null;
        });
    }
    Ye() {
        if (this.He != null) {
            return this.He;
        }
        if (this.Et === "") {
            const t = this.$.Kt;
            const n = this.$.element?.ownerDocument || document;
            const e = gr(n, t);
            return this.He = e[+this.gt];
        }
        ze && this.Et && We(this.Et, 1);
        const t = this.gt;
        const n = this.Qe ? this.Qe().then(n => n[t]) : ri().importSymbol(this.$?.element, this.Et, t);
        this.Je(n);
        return this.He;
    }
}

const ua = Symbol();

const ca = t => t?.[ua] ?? t;

class fa {
    Ge;
    resolved=void 0;
    Ot;
    $;
    constructor(t, n, e) {
        this.Ge = t;
        if (n) {
            this.Ot = n;
            typeof n === "string" && (this.$ = e);
        }
        t.He == null || this.Ot && typeof this.Ot === "string" || fi(t.He) || (this.resolved = ma(this, t.He));
    }
}

const aa = function(t, ...n) {
    const e = ca(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = Qf();
    return ha.call(e, s?.$).then(() => Le.call(t, s, e.resolved, n));
};

const ha = async function(t) {
    const n = ca(this);
    return hi(va(n, t), () => n.resolved);
};

const da = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[ua].resolved;
        },
        set(t) {
            this[ua].resolved = t;
        }
    },
    Ot: {
        get() {
            return this[ua].Ot;
        },
        set(t) {
            this[ua].Ot = t;
        }
    },
    jt: {
        get() {
            return this[ua].Ge.jt;
        }
    },
    $: {
        get() {
            return this[ua].$;
        },
        set(t) {
            this[ua].$ = t;
        }
    },
    Ge: {
        get() {
            return this[ua].Ge;
        }
    },
    Et: {
        get() {
            return this[ua].Ge.Et;
        }
    },
    gt: {
        get() {
            return this[ua].Ge.gt;
        }
    },
    ot: {
        get() {
            return this[ua].Ge.ot;
        }
    },
    dev: {
        get() {
            return this[ua].Ge.dev;
        }
    },
    Ze: {
        value: aa
    },
    w: {
        value: function(t) {
            const n = ca(this);
            const e = new fa(n.Ge, t, n.Ot ? n.$ : void 0);
            return _a(e);
        }
    },
    m: {
        value: function() {
            this[ua].Ge.jt = !0;
            return this;
        }
    },
    s: {
        value: function(t) {
            const n = ca(this);
            n.Ge.Je(t);
            n.resolved = ma(n, t);
        }
    },
    resolve: {
        value: ha
    },
    getSymbol: {
        value: function() {
            return ca(this).Ge.gt;
        }
    },
    getHash: {
        value: function() {
            return ca(this).Ge.ot;
        }
    },
    getCaptured: {
        value: function() {
            const t = ca(this);
            wa(t);
            return t.Ot;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = ca(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return ha.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return Le(t, e.resolved, o);
            };
            return s;
        }
    }
});

let pa = null;

const $a = t => {
    pa = t;
};

const ya = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t.k(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const wa = t => {
    const n = t.Ot;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw er(13);
        }
        const s = Gc;
        pa = t.Ot = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return ya(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return ya(t, n, s + 1, o);
        })(e, n);
        if (Gc !== s) {
            return Gc;
        }
    } else {
        pa = n || null;
    }
};

const ma = (t, n) => {
    if (typeof n !== "function" || !t.Ot) {
        return n;
    }
    return function e(...s) {
        wa(t);
        return n.apply(this, s);
    };
};

const va = (t, n) => {
    const e = t.Ge;
    const s = typeof t.Ot === "string";
    s && !t.$ && (t.$ = n || Qf()?.$);
    if (t.resolved) {
        return;
    }
    const o = ka();
    const r = Qf();
    const i = e.Ye();
    const c = hi(i, n => {
        t.resolved = ma(t, n);
    });
    if (c) {
        const t = e.gt;
        Ea(t, r?._ instanceof xi ? r?._.node : void 0, o);
    }
    const l = s && t.$ && wa(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const ba = (t, n, e, s, o, r) => {
    const i = ((t, n, e, s, o) => new la(t, n, e, s, o))(t, n, s, e, r);
    const c = new fa(i, o, r);
    return _a(c);
};

const _a = t => {
    const n = async function(...t) {
        return aa.call(n, this, ...t);
    };
    n[ua] = t;
    Object.setPrototypeOf(n, da);
    return n;
};

const ga = /*#__PURE__*/ new Set;

const Ea = (t, n, e) => {
    if (!ga.has(t)) {
        ga.add(t);
        Sa("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const Sa = (t, n) => {
    gd() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const ka = () => {
    if (gd()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Ra = 0;

const Pa = t => ba(null, "s" + Ra++, t, null, null);

const Ta = Pa;

const Aa = t => t;

const qa = t => ba("", ir, t, null, null);

const Ia = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return ba("", ir, t, null, null);
};

const Ma = t => {
    function n(n, e, s = 0) {
        const o = t.ot.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[Na] = [ t ];
        return Hs(i, n, null, n.children, s, r);
    }
    n[Na] = [ t ];
    return n;
};

const Na = Symbol();

const xa = t => typeof t == "function" && t[Na] !== void 0;

const Ca = t => Ma(Ta(t));

const Oa = ys(Aa);

const ja = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const La = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !ui(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(Tr, "resumed");
    const s = Ie(t);
    s.pn = e.serverData || {};
    const o = s.rootVNode;
    yl(o, Xi, n);
    mn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            kt(s, [], s.rootVNode);
        }
    };
};

const Fa = (t, n) => {
    const {val: e, set: s, iCtx: o} = Oo();
    if (e != null) {
        return e;
    }
    const r = nr(t) ? je(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = Du(r, i, t);
        s(c);
        return c;
    }
};

const Xa = t => {
    const n = $i(t);
    return (t => t.toString(36))(n.xe++);
};

const Da = () => {
    const {val: t, set: n, iCtx: e} = Oo();
    if (t != null) {
        return t;
    }
    const s = e.$.Ce || "";
    const o = s ? bo(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e._, or);
    const i = r?.getHash().substring(0, 3) || "";
    const c = Xa(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function De(t, n) {
    const e = Qf();
    return e?.$?.pn[t] ?? n;
}

const Wa = /*#__PURE__*/ new Map;

const Va = (t, n) => {
    let e = Wa.get(n);
    e || Wa.set(n, e = za(t, n));
    return e;
};

const za = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = Ja;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === gh) {
            r++;
            e = vh;
        }
        const s = qh[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, w] = p;
            if (($ === l || $ === ih || $ === sh && Ua(l) || $ === lh && Ha(l)) && (y === e || y === ih || y === sh && Ua(e) || y === oh && !Ua(e) && e !== $h || y === lh && Ha(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (w === eh || w == rh) {
                    if (w === rh) {
                        if (c !== Ya || h()) {
                            if (!Ba(e)) {
                                const t = y == oh ? 1 : y == dh ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            Ba(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === oh) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || Ja;
                        if (c === Ga) {
                            u(r - 1);
                            i++;
                        }
                    } while (Qa(c));
                } else {
                    o.push(c);
                    if (c === Ga && w === Ja) {
                        u(r - 8);
                        i = r;
                    } else {
                        w === Za && f(n);
                    }
                    c = w;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === Ga || h()) {
            return;
        }
        u(t);
        s.push(".", cr, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === ph) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === ph) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | Sh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(Ga) !== -1 || o.indexOf(Ka) !== -1;
    }
};

const Ua = t => t >= yh && t <= wh || t >= vh && t <= bh || t >= kh && t <= Rh || t >= 128 || t === Eh || t === ph;

const Ba = t => t === mh || t === $h || t === _h || t === hh || Ua(t);

const Qa = t => t === th || t === Ka || t === nh || t === Ga;

const Ha = t => t === ah || t === uh || t === ch || t === fh;

const Ja = 0;

const Ya = 2;

const Ga = 5;

const Za = 6;

const Ka = 10;

const th = 11;

const nh = 12;

const eh = 17;

const rh = 18;

const ih = 0;

const sh = 1;

const oh = 2;

const lh = 3;

const uh = 9;

const ch = 10;

const fh = 13;

const ah = 32;

const hh = 35;

const dh = 41;

const ph = 45;

const $h = 46;

const yh = 48;

const wh = 57;

const mh = 58;

const vh = 65;

const bh = 90;

const _h = 91;

const gh = 92;

const Eh = 95;

const Sh = 32;

const kh = 97;

const Rh = 122;

const Ph = 123;

const Th = 125;

const Ah = /*@__PURE__*/ (() => [ [ ih, 39, 14 ], [ ih, 34, 15 ], [ ih, 47, 16, "*" ] ])();

const qh = /*@__PURE__*/ (() => [ [ [ ih, 42, Ya ], [ ih, _h, 7 ], [ ih, mh, Za, ":", "before", "after", "first-letter", "first-line" ], [ ih, mh, Ga, "global" ], [ ih, mh, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ ih, mh, 4 ], [ ih, sh, 1 ], [ ih, $h, 1 ], [ ih, hh, 1 ], [ ih, 64, Ka, "keyframe" ], [ ih, 64, th, "media", "supports", "container" ], [ ih, 64, nh ], [ ih, Ph, 13 ], [ 47, 42, 16 ], [ ih, 59, eh ], [ ih, Th, eh ], [ ih, dh, eh ], ...Ah ], [ [ ih, oh, rh ] ], [ [ ih, oh, rh ] ], [ [ ih, 40, Ja ], [ ih, oh, rh ] ], [ [ ih, 40, 8 ], [ ih, oh, rh ] ], [ [ ih, 40, Ja ], [ ih, oh, eh ] ], [ [ ih, oh, eh ] ], [ [ ih, 93, rh ], [ ih, 39, 14 ], [ ih, 34, 15 ] ], [ [ ih, dh, eh ], ...Ah ], [ [ ih, Th, eh ], ...Ah ], [ [ ih, Th, eh ], [ lh, sh, 1 ], [ ih, mh, Ga, "global" ], [ ih, Ph, 13 ], ...Ah ], [ [ ih, Ph, Ja ], [ ih, 59, eh ], ...Ah ], [ [ ih, 59, eh ], [ ih, Ph, 9 ], ...Ah ], [ [ ih, Th, eh ], [ ih, Ph, 13 ], [ ih, 40, 8 ], ...Ah ], [ [ ih, 39, eh ] ], [ [ ih, 34, eh ] ], [ [ 42, 47, eh ] ] ])();

const Ih = t => ({
    styleId: Ch(t, t => t, !1)
});

const Mh = /*#__PURE__*/ ys(Ih);

const Nh = t => ({
    scopeId: cr + Ch(t, Va, !0)
});

const xh = /*#__PURE__*/ ys(Nh);

const Ch = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Oo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${bo(t.ot)}-${n}`)(t, i);
    const l = r._;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.Be(n(t, c), c, l, e));
    }
    r.$.Be(n(t.resolved, c), c, l, e);
    return c;
};

const Oh = (t, n) => {
    t.resolve();
    return bs(t, n);
};

const jh = (t, n) => Fo(Oh, t, n);

const Lh = ys(jh);

const Fh = t => {
    t.resolve();
    return gs(t);
};

const Xh = t => Fo(Fh, t);

const Dh = ys(Xh);

const Wh = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Oo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !gd()) {
            e.h |= 32;
            Vh(e, i);
        }
        return;
    }
    let c;
    if (gd() || i === "intersection-observer") {
        c = 1;
        gd() || t.resolve();
    } else {
        c = 5;
        t.resolve();
        mn(r.$, r._, 1);
    }
    const l = new _u(c, o, r._, t, null);
    s(l);
    Vh(l, i);
};

const Vh = (t, n) => {
    n === "intersection-observer" ? zc("qvisible", zh(t)) : n === "document-ready" ? Uc("qinit", zh(t)) : n === "document-idle" && Uc("qidle", zh(t));
};

const zh = t => ba(null, "_task", Mn, null, [ t ]);

const Uh = ys(Dc);

const Bh = /*#__PURE__*/ ys(vu);

const Qh = /*#__PURE__*/ ys(Wh);

const Hh = () => Object.defineProperty({
    error: void 0
}, "error", {
    enumerable: !1
});

async function Nd(t, n, e, s) {
    const o = n + "";
    const r = await e.container.S(o, e);
    t.write(`<template ${pr}="${n}"${s?.attrs ?? ""}>`);
    t.write(r.html);
    t.write("</template>");
    t.emitOutOfOrderSegmentScripts(r.scripts);
    t.emitOutOfOrderExecutorIfNeeded();
    t.emitInlineScript(`qO(${n})`);
    const i = e.container.P;
    if (__EXPERIMENTAL__.errorBoundary && i?.length) {
        t.emitErrorSwapExecutorIfNeeded();
        for (let n = 0; n < i.length; n++) {
            t.emitInlineScript(`qErr(${i[n]})`);
        }
    }
    await t.streamHandler.flush();
}

const Jh = () => {
    const [t] = pa;
    const n = Qf()?.$;
    const e = ze;
    e && t && n && function s(t, n) {
        const e = t.resolveContextHost(n, _f);
        if (!e) {
            return;
        }
        const s = ve(t, e);
        if (!s) {
            return;
        }
        (function o(t, n, e) {
            let s = n;
            let o = null;
            let r = au(n);
            let i = !1;
            for (;r; ) {
                if (dl(r)) {
                    if ($l(r, fr, null) !== null) {
                        i = !0;
                    } else if ($l(r, or, null) !== null) {
                        if (!i) {
                            const n = ve(t, r);
                            if (!n || n.error !== void 0) {
                                o && (s = o);
                                o = r;
                                if (n?.error !== void 0 || !k(r.props)) {
                                    break;
                                }
                            }
                        }
                        i = !1;
                    }
                }
                r = au(r);
            }
            if (e && e !== o) {
                s = o ?? s;
                o = e;
            }
            if (o) {
                s.key = `${s.key ?? ""}${Yh}`;
                mn(t, o, 4);
            } else {
                mn(t, n, 4);
            }
        })(t, e, s.projectedContentOwner ?? null);
        s.error = void 0;
    }(n, t);
};

const Yh = "\0";

const Gh = t => {
    if (!__EXPERIMENTAL__.errorBoundary) {
        throw Error('<ErrorBoundary> requires the `errorBoundary` experimental feature. Enable it in your Qwik Vite config: qwikVite({ experimental: ["errorBoundary"] }).');
    }
    const n = (() => {
        const t = Fa(Hh);
        mf(_f, t);
        return t;
    })();
    const e = Qf();
    const s = e?.$;
    s && (Ou(n) ?? n).boundaryId === void 0 && (n.boundaryId = Xa(s));
    const o = !ze;
    if (!o && n.error === void 0) {
        return /* @__PURE__ */ Qs(io, null, null, null, 0, null);
    }
    const r = /*#__PURE__*/ Sc(Jh, "_ebR", [ e?._ ]);
    if (o) {
        const e = t.fallback$;
        n.It = pf(t => e(t, r));
        const o = t.onError$;
        o && (n.Xe = pf((t, n) => o(t, n)));
        return ((t, n) => {
            const e = n?.nextOutOfOrderId(!1) ?? 0;
            return [ 
            /*#__PURE__*/ Qs("div", {
                [$r]: e + "",
                style: "display:contents"
            }, null, 
            /*#__PURE__*/ Qs(io, null, null, null, 0, null), 1, null), 
            /*#__PURE__*/ Qs(Od, {
                boundaryId: e,
                store: t
            }, null, null, 1, null) ];
        })(n, s);
    }
    const i = Tf(n.error, !0);
    return /* @__PURE__ */ Qs(eo, null, null, ((t, n, e) => t(n, e).catch(n => {
        if (t.resolved !== void 0) {
            throw n;
        }
        return /* @__PURE__ */ Qs("div", {
            role: "alert"
        }, null, "Something went wrong.", 0, null);
    }))(t.fallback$, i, r), 0, null);
};

const Zh = 
/*#__PURE__*/ Ma(
/*#__PURE__*/ Sc(Gh, "_ebC"));

const xd = (t, n) => {
    const e = n.It;
    delete n.It;
    const s = Tf(n.error, Ue, t.I);
    return e(s);
};

const Cd = __EXPERIMENTAL__.errorBoundary ? /*#__PURE__*/ Rd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    if (n.varProps.deliverLate) {
        const n = async n => {
            if (!r.It) {
                return;
            }
            r.error !== n && xf(r, n, "render");
            const s = await t.segment("" + o, xd(t, r), e);
            s.container.A(o);
            await t.C(() => Nd(t, o, s, null));
        };
        r.Nt = pf(n);
        t.write(`<template ${pr}="${o}"></template>`);
        if (r.error !== void 0) {
            return n(r.error);
        }
        return;
    }
    if (r.error === void 0 || !r.It) {
        return;
    }
    Ed(t) ? t.A(o) : s(() => {
        t.emitErrorSwapExecutorIfNeeded();
        t.emitInlineScript(`qErr(${o})`);
    });
    s(xd(t, r));
}) : null;

const Od = __EXPERIMENTAL__.errorBoundary ? /*#__PURE__*/ Rd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    const i = __EXPERIMENTAL__.suspense && t.outOfOrderStreaming && !Ed(t) && (r.error === void 0 || (t => qf.has(t))(r));
    s(
    /*#__PURE__*/ Qs("div", {
        [i ? _d : "q:ebf"]: o + "",
        style: "display:none"
    }, null, 
    /*#__PURE__*/ Qs(Cd, {
        boundaryId: o,
        store: r,
        deliverLate: i
    }, null, null, 1, null), 1, null));
}) : null;

const Kh = async ({track: t}) => {
    const n = pa[0];
    t(() => n.items);
    const e = Qf();
    const s = e._;
    const o = e.$;
    const r = mn(o, s, 256);
    const i = Ve;
    i && await r;
};

const td = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    vu(/*#__PURE__*/ Sc(Kh, "_eaT", [ t ]));
    return so;
};

const nd = /*#__PURE__*/ Ma(
/*#__PURE__*/ Sc(td, "_eaC"));

const ed = (t, n, e) => sr(t) ? t.getFn(n)(e) : t(e);

const rd = ({track: t}) => {
    const n = pa[0];
    const e = Qf();
    const s = e._;
    const o = e.$;
    const r = Ve;
    return hi(t(() => ed(n.when$, Qf(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return hi(i ? ed(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Bt(s, n);
            mn(o, s, 2);
        });
    });
};

const id = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    vu(/*#__PURE__*/ Sc(rd, "_shT", [ t ]));
    return so;
};

const sd = /*#__PURE__*/ Ma(
/*#__PURE__*/ Sc(id, "_shC"));

const od = /*#__PURE__*/ wf("qk-reveal");

const ld = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Es(0)
});

const ud = () => {
    const t = pa[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!ze) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return Pd(t);
};

const cd = ({cleanup: t}) => {
    const n = pa[0];
    t(() => {
        if (!ze) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const fd = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Fo(ld, t);
    mf(od, n);
    const e = !ze;
    if (__EXPERIMENTAL__.suspense && e && Ad()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                const e = Qf().$;
                const s = (Td.get(e) || 0) + 1;
                Td.set(e, s);
                return new qd(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = pf(e);
            return e;
        })(n);
        return /* @__PURE__ */ Qs(Ld, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    return /* @__PURE__ */ Qs(io, null, null, null, 0, "u7_0");
};

const ad = /*#__PURE__*/ Ma(
/*#__PURE__*/ Sc(fd, "_reC"));

const Ld = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Rd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ Qs(io, null, null, null, 0, "u7_0"));
}) : null;

const hd = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || !e.value && s.reveal.collapsed ? "none" : "contents"
});

const jd = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const dd = (t, n) => ({
    display: t.value === "content" && n.value ? "contents" : "none"
});

const pd = ({track: t, cleanup: n}) => {
    const e = pa[0], s = pa[1], o = pa[2], r = pa[3];
    const i = t(e);
    const c = ze;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const $d = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Lo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return Lo(0);
    })();
    const s = (t => {
        const n = vf(od, null);
        const e = Fo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && vu(/*#__PURE__*/ Sc(cd, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = jh(
    /*#__PURE__*/ Sc(ud, "_reR", [ s ]));
    vu(
    /*#__PURE__*/ Sc(pd, "_suT", [ e, t, n, s ]));
    const r = !ze;
    const i = r && Ad();
    const c = i ? (() => Qf().$.nextOutOfOrderId())() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && Gf(() => t.fallback != null && t.fallback !== !1) && (l === null || l.showFallback);
    const f = u && function a(t) {
        return typeof t === "number" && Number.isFinite(t) && t > 0;
    }(t.delay) ? {
        contentResolved: !1,
        delay: t.delay,
        delayTimer: null
    } : null;
    const h = /*#__PURE__*/ Mc(dd, [ n, o ], '{display:p0.value==="content"&&p1.value?"contents":"none"}');
    const d = i ? /*#__PURE__*/ Qs(Fd, {
        boundary: f,
        fallbackStyle: Mc(hd, [ t, n, o, s ], jd),
        showFallback: u,
        state: n
    }, null, As(t, "fallback"), 1, null) : /*#__PURE__*/ Qs("div", {
        style: Mc(hd, [ t, n, o, s ], jd)
    }, null, As(t, "fallback"), 1, null);
    return [ d, 
    /*#__PURE__*/ Qs("div", null, i ? {
        [_d]: c + "",
        style: h
    } : {
        style: h
    }, 
    /*#__PURE__*/ Qs(i ? Xd : io, i ? {
        [Hr]: e,
        boundary: f,
        boundaryId: c,
        contentStyle: h,
        reveal: l
    } : {
        [Hr]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const yd = /*#__PURE__*/ Ma(
/*#__PURE__*/ Sc($d, "_suC"));

const Fd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Rd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.fallbackStyle;
    const i = n.varProps.showFallback === !0;
    const c = n.varProps.state;
    i && (o ? s(() => function n(t, e, s) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.C(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, e.delay);
    }(t, o, c)) : c.value = "fallback");
    s(
    /*#__PURE__*/ Qs("div", {
        style: r
    }, null, n.children, 1, null));
}) : null;

const Xd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ Rd(async (t, n, e) => {
    const s = n.varProps.boundaryId;
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = __EXPERIMENTAL__.errorBoundary && e.parentComponentFrame ? t.resolveContext(e.parentComponentFrame.componentNode, _f) : void 0;
    const u = t.segment(o, function f(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            return /* @__PURE__ */ Qs(io, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = R(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        return /* @__PURE__ */ Qs(io, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    t.write(`<template ${pr}="${s}"></template>`);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(u.then(n => async function e(t, n, s, o, r, i) {
        if (i) {
            i.contentResolved = !0;
            if (i.delayTimer) {
                clearTimeout(i.delayTimer);
                i.delayTimer = null;
            }
        }
        r?.resolve();
        await t.C(async () => {
            t.addRoot(o);
            await Nd(t, n, s, r);
        });
    }(t, s, n, i, c, r)).catch(t => {
        if (l?.Nt) {
            return l.Nt(t);
        }
        if (l?.error !== void 0) {
            return;
        }
        throw t;
    }));
}) : null;

const wd = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = md.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return Qs("script", null, o, null, 0, "prefetch-service-worker");
};

const md =  "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const vd = () => null;

globalThis.__qwik && er(30, [ globalThis.__qwik, rr ]);

globalThis.__qwik = rr;

export { Pa as $, nd as Each, Zh as ErrorBoundary, eo as Fragment, $f as NoSerializeSymbol, vd as PrefetchGraph, wd as PrefetchServiceWorker, ro as RenderOnce, Wc as Resource, ad as Reveal, lo as SSRComment, oo as SSRRaw, co as SSRStream, uo as SSRStreamBlock, yf as SerializerSymbol, sd as Show, so as SkipRender, io as Slot, yd as Suspense, Ui as _CONST_PROPS, zf as _DomContainer, yi as _EFFECT_BACK_REF, Xr as _ELEMENT_SEQ, Gi as _EMPTY_ARRAY, Zi as _EMPTY_OBJ, Ji as _IMMUTABLE, Nc as _SharedContainer, Ns as _SubscriptionData, Zu as _SubscriptionPatch, _u as _Task, Yi as _UNINITIALIZED, Bi as _VAR_PROPS, re as _addProjection, pa as _captures, v as _chk, we as _createDeserializeContainer, ba as _createQRL, xn as _createStore, di as _delay, $e as _deserialize, $c as _dumpState, td as _eaC, Kh as _eaT, Gh as _ebC, Jh as _ebR, yn as _executeSsrChores, Mc as _fnSignal, ss as _getConstProps, ra as _getContextContainer, ea as _getContextEvent, na as _getContextHostElement, Ie as _getDomContainer, Ne as _getQContainerElement, w as _getSubscriber, is as _getVarProps, Yn as _handleSSRError, Lu as _hasStoreEffects, Jc as _hmr, vs as _injectAsyncSignalValue, je as _invoke, js as _isJSXNode, Xu as _isStore, Un as _isStringifiable, gu as _isTask, ia as _jsxBranch, Js as _jsxC, Gs as _jsxQ, Ys as _jsxS, Qs as _jsxSorted, Hs as _jsxSplit, ii as _mapApp_findIndx, oi as _mapArray_get, si as _mapArray_set, Mu as _markSignalAsExternallyOwned, Xe as _newInvokeContext, kc as _noopQrl, Rc as _noopQrlDEV, Wn as _preprocessState, Ia as _qrlSync, Ln as _qrlToString, Pc as _qrlWithChunk, Tc as _qrlWithChunkDEV, fd as _reC, ud as _reR, cd as _reT, Ic as _regSymbol, oe as _removeProjection, b as _res, bf as _resolveContextWithoutSequentialScope, yo as _restProps, t as _retryOnPromise, Xc as _rsc, C as _run, pe as _serialize, te as _setEvent, ie as _setProjectionTarget, id as _shC, rd as _shT, $d as _suC, pd as _suT, Mn as _task, se as _updateProjectionProps, ee as _useHmr, m as _val, cf as _verifySerializable, bl as _vnode_ensureElementInflated, cu as _vnode_getAttrKeys, Wl as _vnode_getElementName, Ul as _vnode_getFirstChild, $l as _vnode_getProp, Pl as _vnode_getVNodeForChildNode, jl as _vnode_insertBefore, cl as _vnode_isElementVNode, al as _vnode_isMaterialized, hl as _vnode_isTextVNode, dl as _vnode_isVirtualVNode, ll as _vnode_newVirtual, Xl as _vnode_remove, yl as _vnode_setProp, kn as _vnode_toString, sa as _waitUntilRendered, Qn as _walkJSX, As as _wrapProp, Is as _wrapSignal, Ca as component$, Ma as componentQrl, _s as createAsyncQrl, Ss as createComputed$, bs as createComputedQrl, wf as createContextId, _ as createElement, ks as createSerializer$, gs as createSerializerQrl, Es as createSignal, Oa as event$, Aa as eventQrl, ju as forceStoreEffects, ja as getClientManifest, Ie as getDomContainer, Ce as getLocale, ri as getPlatform, _ as h, ys as implicit$FirstArg, Sc as inlinedQrl, qc as inlinedQrlDEV, Ue as isDev, Su as isSignal, Ks as jsx, to as jsxDEV, no as jsxs, pf as noSerialize, Ec as qrl, Ac as qrlDEV, La as render, ei as setPlatform, qa as sync$, Gf as untrack, Fu as unwrapStore, Lh as useComputed$, jh as useComputedQrl, Fo as useConstant, vf as useContext, mf as useContextProvider, Da as useId, Fc as useLexicalScope, zc as useOn, Uc as useOnDocument, Bc as useOnWindow, Uh as useResource$, Dc as useResourceQrl, Dh as useSerializer$, Xh as useSerializerQrl, De as useServerData, Lo as useSignal, Fa as useStore, Mh as useStyles$, Ih as useStylesQrl, xh as useStylesScoped$, Nh as useStylesScopedQrl, Bh as useTask$, vu as useTaskQrl, Qh as useVisibleTask$, Wh as useVisibleTaskQrl, rr as version, Oe as withLocale };
